import { AjaxHandler } from '../index';
import { createElement, Browser, initializeCSPTemplate, isNullOrUndefined, getComponent, Draggable, Droppable } from '@syncfusion/ej2-base';
import { Tooltip, Dialog } from '@syncfusion/ej2-popups';
import { CheckBox } from '@syncfusion/ej2-buttons';
import { DropDownButton } from '@syncfusion/ej2-splitbuttons';
import { Toolbar, ContextMenu } from '@syncfusion/ej2-navigations';
import { createSpinner, showSpinner, hideSpinner } from '../base/spinner';
import { TaskPriorityLevel } from '../base/pdfviewer-utlis';
import { Slider } from '@syncfusion/ej2-inputs';
/**
 * The `PageOrganizer` module is used to handle page organize operations of PDF viewer.
 *
 * @param {Event} event - The event triggering the page organization.
 * @param {Object} args - Additional arguments for the page organization.
 * @returns {void}
 */
export class PageOrganizer {
    /**
     * @param {PdfViewer} pdfViewer - It describes about the pdfviewer
     * @param {PdfViewerBase} pdfViewerBase - It describes about the pdfviewer base
     * @private
     */
    constructor(pdfViewer, pdfViewerBase) {
        this.previewLimit = 5;
        this.lastRequestedPageIndex = 0;
        this.pageZoomSliderStep = 0.25;
        /**
         * @private
         */
        this.dataDetails = [];
        this.mobileContextMenu = [];
        /**
         * @private
         */
        this.organizePagesCollection = [];
        this.tempOrganizePagesCollection = [];
        this.isSkipRevert = false;
        this.isAllImagesReceived = false;
        this.selectedPageIndexes = [];
        this.autoScrollInterval = null;
        this.gapBetweenDivs = 48;
        this.previousImageZoom = 1;
        /**
         * @private
         */
        this.isDocumentModified = false;
        /**
         * @private
         */
        this.undoOrganizeCollection = [];
        /**
         * @private
         */
        this.redoOrganizeCollection = [];
        /**
         * @private
         */
        this.toolbarUndoRedoCollection = [];
        this.isTouchEvent = false;
        this.isPageZoomChanged = false;
        this.isInitialLoading = true;
        /**
         * @private
         */
        this.isOrganizeWindowOpen = false;
        this.isPageZoomPopupOpen = false;
        this.pageDragDrop = (event) => {
            const mainTileElement = event.target.closest('.e-pv-organize-anchor-node');
            const pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
            this.dragEndIndex = pageOrder;
            this.movePDFpages(this.selectedPageIndexes, this.dragEndIndex, this.isRightInsertion);
        };
        /**
         * @param {MouseEvent} event - It describes about the event
         * @private
         * @returns {void}
         */
        this.thumbnailMouseOver = (event) => {
            // eslint-disable-next-line
            const proxy = this;
            if (event.currentTarget instanceof HTMLElement) {
                // Convert HTMLCollection to an array
                const childrenArray = Array.from(event.currentTarget.children);
                // Iterate over the array
                for (const subchild of childrenArray) {
                    const childArray = Array.from(subchild.children);
                    for (const child of childArray) {
                        // Exclude the image by checking its type
                        if (!(child.classList.contains('e-pv-image-container'))) {
                            // Set the display style property to "none" for other children
                            child.style.display = 'flex';
                            if (child.classList.contains('e-checkbox-wrapper')) {
                                child.children[0].style.display = 'block';
                            }
                            else if (child.classList.contains('e-pv-organize-buttondiv') && child.childElementCount > 0) {
                                const childelementArray = Array.from(child.children);
                                for (const childelement of childelementArray) {
                                    if (proxy.totalCheckedCount > 1) {
                                        if (childelement.id.split('_')[1] === 'insert') {
                                            childelement.style.display = 'flex';
                                        }
                                        else {
                                            childelement.style.display = 'none';
                                        }
                                    }
                                    else {
                                        childelement.style.display = 'flex';
                                    }
                                    const targetClassList = childelement.classList;
                                    if (targetClassList.contains('e-pv-insert-left-button') || targetClassList.contains('e-pv-insert-right-button')) {
                                        childelement.style.top = '-' + (parseFloat(this.pageLink.style.height.replace('px', '')) / 2) + 'px';
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };
        /**
         * @param {MouseEvent} event - It describes about the event
         * @private
         * @returns {void}
         */
        this.thumbnailMouseLeave = (event) => {
            if (event.currentTarget instanceof HTMLElement) {
                // Convert HTMLCollection to an array
                const childrenArray = Array.from(event.currentTarget.children);
                // Iterate over the array
                for (const subchild of childrenArray) {
                    const childArray = Array.from(subchild.children);
                    for (const child of childArray) {
                        // Exclude the image by checking its type
                        if (!(child.classList.contains('e-pv-image-container'))) {
                            if (event.currentTarget.classList.contains('e-pv-organize-node-selection-ring')) {
                                if (child.classList.contains('e-checkbox-wrapper')) {
                                    child.style.display = 'block';
                                }
                                else {
                                    child.style.display = 'none';
                                }
                            }
                            else {
                                // Set the display style property to "none" for other children
                                child.style.display = 'none';
                            }
                        }
                    }
                }
            }
        };
        this.onSelectClick = (args) => {
            const checkboxElement = event.currentTarget.querySelector('.e-pv-organize-tile-checkbox');
            const pageElement = checkboxElement.closest('.e-pv-organize-anchor-node');
            if (args.event.pointerType === 'mouse' || (!this.isTouchEvent && !(Browser.isDevice && !this.pdfViewer.enableDesktopMode))) {
                if (this.isClickedOnCheckBox && !isNullOrUndefined(checkboxElement) && !isNullOrUndefined(pageElement)) {
                    if (pageElement) {
                        this.setSelectionRingStyle(checkboxElement, pageElement);
                    }
                }
                else if (!isNullOrUndefined(checkboxElement) && !isNullOrUndefined(pageElement)) {
                    if (!(this.ctrlKey || this.shiftKey)) {
                        const previouslySelectedTiles = document.querySelectorAll('.e-pv-organize-node-selection-ring');
                        if (previouslySelectedTiles.length > 0) {
                            for (let i = 0; i < previouslySelectedTiles.length; i++) {
                                const previousCheckbox = previouslySelectedTiles[parseInt(i.toString(), 10)].closest('.e-pv-organize-anchor-node').querySelector('.e-pv-organize-tile-checkbox');
                                previousCheckbox.checked = false;
                                this.setSelectionRingStyle(previousCheckbox, previouslySelectedTiles[parseInt(i.toString(), 10)]);
                            }
                        }
                        if (!this.isClickedOnCheckBox) {
                            checkboxElement.checked = true;
                        }
                    }
                    if (this.shiftKey) {
                        checkboxElement.checked = true;
                    }
                    this.setSelectionRingStyle(checkboxElement, pageElement);
                }
            }
            else if (args.event.pointerType === 'touch' || this.isTouchEvent || (Browser.isDevice && !this.pdfViewer.enableDesktopMode)) {
                if (!isNullOrUndefined(checkboxElement) && !isNullOrUndefined(pageElement)) {
                    if (pageElement) {
                        this.setSelectionRingStyle(checkboxElement, pageElement);
                    }
                }
            }
            this.updateSelectAllCheckbox();
            this.enableDisableToolbarItems();
            if (this.totalCheckedCount > 1) {
                for (let i = 0; i < pageElement.querySelector('.e-pv-organize-buttondiv').childElementCount; i++) {
                    const id = pageElement.querySelector('.e-pv-organize-buttondiv').children[parseInt(i.toString(), 10)].id;
                    if (id.split('_')[1] === 'insert') {
                        pageElement.querySelector('.e-pv-organize-buttondiv').children[parseInt(i.toString(), 10)].style.display = 'flex';
                    }
                    else {
                        pageElement.querySelector('.e-pv-organize-buttondiv').children[parseInt(i.toString(), 10)].style.display = 'none';
                    }
                }
            }
        };
        this.rotateButtonClick = (event) => {
            if (this.pdfViewer.pageOrganizerSettings.canRotate) {
                const rotateButton = event.currentTarget;
                const mainTileElement = rotateButton.closest('.e-pv-organize-anchor-node');
                const imageContainer = mainTileElement.querySelector('.e-pv-organize-image');
                const pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
                if (imageContainer) {
                    // Get the current rotation angle of the image container (if any)
                    let currentRotation = parseFloat(imageContainer.style.transform.replace('rotate(', '').replace('deg)', '')) || 0;
                    // Calculate the new rotation angle (add 90 degrees)
                    currentRotation += 90;
                    // Ensure that the rotation stays within the desired range (0, 90, 180, 270, 360)
                    if (currentRotation >= 360) {
                        currentRotation = 0;
                    }
                    // Apply the rotation to the image container
                    imageContainer.style.transform = `rotate(${currentRotation}deg)`;
                    // Update the rotation value in the pageDetails collection
                    this.updateTempRotationDetail(pageOrder, 90);
                    const clonedCollection = [];
                    clonedCollection.push(this.clonedCollection(this.tempOrganizePagesCollection.
                        find((item) => { return item.currentPageIndex === pageOrder; })));
                    this.addOrganizeAction(clonedCollection, 'Rotate Right', [], [], null, false);
                }
            }
        };
        this.rotateLeftButtonClick = (event) => {
            if (this.pdfViewer.pageOrganizerSettings.canRotate) {
                const rotateButton = event.currentTarget;
                const mainTileElement = rotateButton.closest('.e-pv-organize-anchor-node');
                const imageContainer = mainTileElement.querySelector('.e-pv-organize-image');
                const pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
                if (imageContainer) {
                    // Get the current rotation angle of the image container (if any)
                    let currentRotation = parseFloat(imageContainer.style.transform.replace('rotate(', '').replace('deg)', '')) || 0;
                    // Calculate the new rotation angle (add 90 degrees)
                    currentRotation -= 90;
                    // Ensure that the rotation stays within the desired range (0, 90, 180, 270, 360)
                    if (currentRotation >= 360) {
                        currentRotation = 0;
                    }
                    if (currentRotation === -90) {
                        currentRotation = 270;
                    }
                    // Apply the rotation to the image container
                    imageContainer.style.transform = `rotate(${currentRotation}deg)`;
                    // Update the rotation value in the pageDetails collection
                    this.updateTempRotationDetail(pageOrder, -90);
                    const clonedCollection = [];
                    clonedCollection.push(this.clonedCollection(this.tempOrganizePagesCollection.
                        find((item) => { return item.currentPageIndex === pageOrder; })));
                    this.addOrganizeAction(clonedCollection, 'Rotate Left', [], [], null, false);
                }
            }
        };
        this.onToolbarRightButtonClick = () => {
            if (this.pdfViewer.pageOrganizerSettings.canRotate) {
                // eslint-disable-next-line
                const proxy = this;
                for (let i = 0; i < proxy.tileAreaDiv.childElementCount; i++) {
                    const mainTileElement = proxy.tileAreaDiv.childNodes[parseInt(i.toString(), 10)];
                    // Type assertion to HTMLElement
                    if (mainTileElement instanceof HTMLElement && mainTileElement.classList.contains('e-pv-organize-node-selection-ring')) {
                        const imageContainer = mainTileElement.querySelector('.e-pv-organize-image');
                        const pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
                        if (imageContainer) {
                            // Get the current rotation angle of the image container (if any)
                            let currentRotation = parseFloat(imageContainer.style.transform.replace('rotate(', '').replace('deg)', '')) || 0;
                            // Calculate the new rotation angle (add 90 degrees)
                            currentRotation += 90;
                            // Ensure that the rotation stays within the desired range (0, 90, 180, 270, 360)
                            if (currentRotation >= 360) {
                                currentRotation = 0;
                            }
                            // Apply the rotation to the image container
                            imageContainer.style.transform = `rotate(${currentRotation}deg)`;
                            // Update the rotation value in the pageDetails collection
                            this.updateTempRotationDetail(pageOrder, 90);
                            this.toolbarUndoRedoCollection.
                                push(this.clonedCollection(this.tempOrganizePagesCollection.
                                find((item) => { return item.currentPageIndex === pageOrder; })));
                        }
                    }
                }
                this.addOrganizeAction(null, 'Toolbar Rotate Right', this.toolbarUndoRedoCollection, [], null, false);
                this.toolbarUndoRedoCollection = [];
            }
        };
        this.onToolbarLeftButtonClick = () => {
            // eslint-disable-next-line
            const proxy = this;
            for (let i = 0; i < proxy.tileAreaDiv.childElementCount; i++) {
                const mainTileElement = proxy.tileAreaDiv.childNodes[parseInt(i.toString(), 10)];
                // Type assertion to HTMLElement
                if (mainTileElement instanceof HTMLElement && mainTileElement.classList.contains('e-pv-organize-node-selection-ring')) {
                    const imageContainer = mainTileElement.querySelector('.e-pv-organize-image');
                    const pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
                    if (imageContainer) {
                        // Get the current rotation angle of the image container (if any)
                        let currentRotation = parseFloat(imageContainer.style.transform.replace('rotate(', '').replace('deg)', '')) || 0;
                        // Calculate the new rotation angle (add 90 degrees)
                        currentRotation -= 90;
                        // Ensure that the rotation stays within the desired range (0, 90, 180, 270, 360)
                        if (currentRotation >= 360) {
                            currentRotation = 0;
                        }
                        if (currentRotation === -90) {
                            currentRotation = 270;
                        }
                        // Apply the rotation to the image container
                        imageContainer.style.transform = `rotate(${currentRotation}deg)`;
                        // Update the rotation value in the pageDetails collection
                        this.updateTempRotationDetail(pageOrder, -90);
                        this.toolbarUndoRedoCollection.
                            push(this.clonedCollection(this.tempOrganizePagesCollection.
                            find((item) => { return item.currentPageIndex === pageOrder; })));
                    }
                }
            }
            this.addOrganizeAction(null, 'Toolbar Rotate Left', this.toolbarUndoRedoCollection, [], null, false);
            this.toolbarUndoRedoCollection = [];
        };
        this.onToolbarCopyButtonClick = () => {
            if (this.pdfViewer.pageOrganizerSettings.canCopy) {
                // eslint-disable-next-line
                const proxy = this;
                for (let i = 0; i < proxy.tileAreaDiv.childElementCount; i++) {
                    const mainTileElement = proxy.tileAreaDiv.childNodes[parseInt(i.toString(), 10)];
                    if (mainTileElement instanceof HTMLElement && mainTileElement.classList.contains('e-pv-organize-node-selection-ring')) {
                        const pageId = mainTileElement.id.split('anchor_page_')[mainTileElement.id.split('anchor_page_').length - 1];
                        const pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
                        const pageIdlist = pageId.split('_');
                        let subIndex = 0;
                        let pageIndex = parseInt(pageIdlist[parseInt((pageIdlist.length - 1).toString(), 10)], 10);
                        if (pageIdlist.length > 1) {
                            pageIndex = parseInt(pageIdlist[parseInt((pageIdlist.length - 2).toString(), 10)], 10);
                        }
                        subIndex = this.getNextSubIndex(mainTileElement.parentElement, pageIndex);
                        this.copyPage(pageOrder, mainTileElement);
                        this.tileImageRender(pageIndex, subIndex, pageOrder + 1, mainTileElement, true, false, false);
                        this.updatePageNumber();
                        this.toolbarUndoRedoCollection.
                            push(this.clonedCollection(this.tempOrganizePagesCollection.
                            find((item) => { return item.currentPageIndex === (pageOrder + 1); })));
                    }
                }
                this.updateTotalPageCount();
                this.disableTileDeleteButton();
                this.addOrganizeAction(null, 'Toolbar Copy', this.toolbarUndoRedoCollection, [], null, false);
                this.toolbarUndoRedoCollection = [];
            }
        };
        this.onToolbarDeleteButtonClick = () => {
            if (this.pdfViewer.pageOrganizerSettings.canDelete) {
                // eslint-disable-next-line
                const proxy = this;
                const selectedNodes = proxy.tileAreaDiv.querySelectorAll('.e-pv-organize-node-selection-ring');
                selectedNodes.forEach((selectedElements) => {
                    const mainTileElement = selectedElements.closest('.e-pv-organize-anchor-node');
                    const pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
                    this.toolbarUndoRedoCollection.
                        push(this.clonedCollection(this.tempOrganizePagesCollection.
                        find((item) => { return item.currentPageIndex === pageOrder; })));
                });
                selectedNodes.forEach((selectedElement) => {
                    const mainTileElement = selectedElement.closest('.e-pv-organize-anchor-node');
                    proxy.deletePageElement(mainTileElement);
                });
            }
            this.enableDisableToolbarItems();
            this.addOrganizeAction(null, 'Toolbar Delete', this.toolbarUndoRedoCollection, [], null, false);
            this.toolbarUndoRedoCollection = [];
        };
        this.restorePagesBeforeZoom = () => {
            const undoCollectionLength = this.undoOrganizeCollection.length;
            if (undoCollectionLength > 0) {
                /* eslint-disable security/detect-object-injection */
                for (let index = undoCollectionLength - 1; index >= 0; index--) {
                    const undoActionObject = this.undoOrganizeCollection[index];
                    this.undoActionHandler(undoActionObject);
                }
                /* eslint-enable security/detect-object-injection */
            }
        };
        this.restorePagesAfterZoom = () => {
            const undoCollectionLength = this.undoOrganizeCollection.length;
            if (undoCollectionLength > 0) {
                /* eslint-disable security/detect-object-injection */
                for (let index = 0; index < undoCollectionLength; index++) {
                    const redoActionObject = this.undoOrganizeCollection[index];
                    this.redoActionHandler(redoActionObject);
                }
                /* eslint-enable security/detect-object-injection */
            }
        };
        this.undoActionHandler = (undoActionObject) => {
            if (undoActionObject) {
                const actionObject = JSON.parse(JSON.stringify(undoActionObject));
                switch (actionObject.action) {
                    case 'Insert Right':
                    case 'Insert Left':
                    case 'Import Pages':
                    case 'Copy':
                        this.removePage(actionObject.UndoRedoTileActions[0].currentPageIndex);
                        break;
                    case 'Rotate Right':
                        this.rotateImage(actionObject.UndoRedoTileActions[0].currentPageIndex, -90);
                        break;
                    case 'Rotate Left':
                        this.rotateImage(actionObject.UndoRedoTileActions[0].currentPageIndex, 90);
                        break;
                    case 'Delete':
                        {
                            const mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject.UndoRedoTileActions[0].
                                currentPageIndex.toString(), 10)];
                            if (actionObject.UndoRedoTileActions[0].isCopied) {
                                this.insertRemovedPages(actionObject.UndoRedoTileActions[0], actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement);
                                this.tileImageRender(actionObject.UndoRedoTileActions[0].copiedPageIndex, 0, actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement, true, true, false);
                            }
                            else if (actionObject.UndoRedoTileActions[0].isInserted) {
                                this.insertRemovedPages(actionObject.UndoRedoTileActions[0], actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement);
                                this.tileImageRender(actionObject.UndoRedoTileActions[0].copiedPageIndex, 0, actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement, true, true, true);
                            }
                            else if (actionObject.UndoRedoTileActions[0].isImportedDoc) {
                                this.insertRemovedPages(actionObject.UndoRedoTileActions[0], actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement);
                                this.tileImageRender(actionObject.UndoRedoTileActions[0].copiedPageIndex, 0, actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement, true, true, false, true, actionObject.UndoRedoTileActions[0].documentName);
                            }
                            else if (!actionObject.UndoRedoTileActions[0].isCopied && !actionObject.UndoRedoTileActions[0].isInserted
                                && !actionObject.UndoRedoTileActions[0].isImportedDoc) {
                                this.undoDeletedPage(actionObject.UndoRedoTileActions[0].currentPageIndex, actionObject.UndoRedoTileActions[0].pageIndex, actionObject.UndoRedoTileActions[0].rotateAngle, mainTileElement);
                                this.tileImageRender(actionObject.UndoRedoTileActions[0].pageIndex, 0, actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement, true, true, false);
                            }
                            this.updatePageDetail();
                        }
                        break;
                    case 'Move Pages':
                        {
                            const dropIndex = actionObject.dropIndex;
                            const beforeDropIndex = [];
                            const afterDropIndex = [];
                            const processedIndexes = new Set();
                            // Helper function to check if index is in range
                            const isInRange = (start, end, value) => value >= start && value <= end;
                            // Collect all selected indexes
                            for (let i = 0; i < actionObject.UndoRedoTileActions.length; i++) {
                                const action = actionObject.UndoRedoTileActions[parseInt(i.toString(), 10)];
                                const selectedItem = this.tempOrganizePagesCollection
                                    .find((item) => {
                                    if (action.isCopied) {
                                        return item.copiedPageIndex === action.copiedPageIndex && isInRange(dropIndex - actionObject.selectedPagesIndexes.length, dropIndex + actionObject.selectedPagesIndexes.length, item.currentPageIndex) && !processedIndexes.has(item.currentPageIndex);
                                    }
                                    else if (action.isInserted) {
                                        return item.copiedPageIndex === action.copiedPageIndex && item.isInserted && isInRange(dropIndex - actionObject.selectedPagesIndexes.length, dropIndex + actionObject.selectedPagesIndexes.length, item.currentPageIndex) && !processedIndexes.has(item.currentPageIndex);
                                    }
                                    else if (action.isImportedDoc) {
                                        return item.copiedPageIndex === action.copiedPageIndex && item.isImportedDoc && isInRange(dropIndex - actionObject.selectedPagesIndexes.length, dropIndex + actionObject.selectedPagesIndexes.length, item.currentPageIndex) && !processedIndexes.has(item.currentPageIndex);
                                    }
                                    else {
                                        return item.pageIndex === action.pageIndex;
                                    }
                                });
                                if (selectedItem) {
                                    const selectedIndexes = [selectedItem.currentPageIndex];
                                    processedIndexes.add(selectedItem.currentPageIndex);
                                    if (dropIndex < action.currentPageIndex) {
                                        afterDropIndex.push({ currentPageIndex: action.currentPageIndex, selectedIndexes: selectedIndexes });
                                    }
                                    else {
                                        beforeDropIndex.push({ currentPageIndex: action.currentPageIndex, selectedIndexes: selectedIndexes });
                                    }
                                }
                            }
                            // Sort and rearrange for beforeDropIndex
                            if (beforeDropIndex.length > 0) {
                                // Sort in descending order based on selectedIndexes and rearrange
                                beforeDropIndex.sort((a, b) => a.currentPageIndex - b.currentPageIndex);
                                for (let j = 0; j < beforeDropIndex.length; j++) {
                                    // eslint-disable-next-line max-len
                                    this.rearrangePages(beforeDropIndex[parseInt(j.toString(), 10)].selectedIndexes, beforeDropIndex[parseInt(j.toString(), 10)].currentPageIndex, beforeDropIndex[parseInt(j.toString(), 10)].currentPageIndex > beforeDropIndex[parseInt(j.toString(), 10)].selectedIndexes[0]);
                                }
                            }
                            // Sort and rearrange for afterDropIndex
                            if (afterDropIndex.length > 0) {
                                // Sort in ascending order based on currentPageIndex and rearrange
                                afterDropIndex.sort((a, b) => b.currentPageIndex - a.currentPageIndex);
                                for (let j = 0; j < afterDropIndex.length; j++) {
                                    this.rearrangePages(afterDropIndex[parseInt(j.toString(), 10)].selectedIndexes, afterDropIndex[parseInt(j.toString(), 10)].currentPageIndex, afterDropIndex[parseInt(j.toString(), 10)].currentPageIndex >
                                        afterDropIndex[parseInt(j.toString(), 10)].selectedIndexes[0]);
                                }
                            }
                            break;
                        }
                    case 'Toolbar Rotate Right':
                        this.rotateImages(actionObject, -90);
                        break;
                    case 'Toolbar Rotate Left':
                        this.rotateImages(actionObject, 90);
                        break;
                    case 'Toolbar Copy':
                        if (actionObject.toolbarActions.length > 0) {
                            for (let i = actionObject.toolbarActions.length - 1; i >= 0; i--) {
                                const mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject.toolbarActions[parseInt(i.toString(), 10)].
                                    currentPageIndex.toString(), 10)];
                                this.deleteTempPage(actionObject.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement);
                                this.tileAreaDiv.removeChild(mainTileElement);
                                this.updatePageDetail();
                            }
                        }
                        this.disableTileDeleteButton();
                        break;
                    case 'Toolbar Delete':
                        {
                            if (actionObject.toolbarActions.length > 0) {
                                for (let i = 0; i < actionObject.toolbarActions.length; i++) {
                                    const mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject.toolbarActions[parseInt(i.toString(), 10)].
                                        currentPageIndex.toString(), 10)];
                                    if (actionObject.toolbarActions[parseInt(i.toString(), 10)].isCopied) {
                                        this.insertRemovedPages(actionObject.toolbarActions[parseInt(i.toString(), 10)], actionObject.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement);
                                        this.tileImageRender(actionObject.toolbarActions[parseInt(i.toString(), 10)].copiedPageIndex, 0, actionObject.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement, true, true, false);
                                    }
                                    else if (actionObject.toolbarActions[parseInt(i.toString(), 10)].isInserted) {
                                        this.insertRemovedPages(actionObject.toolbarActions[parseInt(i.toString(), 10)], actionObject.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement);
                                        this.tileImageRender(actionObject.toolbarActions[parseInt(i.toString(), 10)].copiedPageIndex, 0, actionObject.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement, true, true, true);
                                    }
                                    else if (actionObject.toolbarActions[parseInt(i.toString(), 10)].isImportedDoc) {
                                        this.insertRemovedPages(actionObject.toolbarActions[parseInt(i.toString(), 10)], actionObject.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement);
                                        this.tileImageRender(actionObject.toolbarActions[parseInt(i.toString(), 10)].copiedPageIndex, 0, actionObject.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement, true, true, false, true, actionObject.toolbarActions[parseInt(i.toString(), 10)].documentName);
                                    }
                                    else if (!actionObject.toolbarActions[parseInt(i.toString(), 10)].isCopied &&
                                        !actionObject.toolbarActions[parseInt(i.toString(), 10)].isInserted &&
                                        !actionObject.toolbarActions[parseInt(i.toString(), 10)].isImportedDoc) {
                                        this.undoDeletedPage(actionObject.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, actionObject.toolbarActions[parseInt(i.toString(), 10)].pageIndex, actionObject.toolbarActions[parseInt(i.toString(), 10)].rotateAngle, mainTileElement);
                                        this.tileImageRender(actionObject.toolbarActions[parseInt(i.toString(), 10)].pageIndex, 0, actionObject.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement, true, true, false);
                                    }
                                    this.updatePageDetail();
                                }
                            }
                            this.disableTileDeleteButton();
                        }
                        break;
                }
            }
        };
        this.redoActionHandler = (redoActionObject) => {
            if (redoActionObject) {
                const actionObject = JSON.parse(JSON.stringify(redoActionObject));
                switch (actionObject.action) {
                    case 'Insert Right':
                    case 'Insert Left':
                        {
                            const mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject.UndoRedoTileActions[0].
                                currentPageIndex.toString(), 10)];
                            this.insertRemovedPages(actionObject.UndoRedoTileActions[0], actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement);
                            this.tileImageRender(actionObject.UndoRedoTileActions[0].copiedPageIndex, 0, actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement, true, true, true);
                            this.disableTileCopyButton();
                            this.updatePageDetail();
                        }
                        break;
                    case 'Rotate Right':
                        this.rotateImage(actionObject.UndoRedoTileActions[0].currentPageIndex, 90);
                        break;
                    case 'Rotate Left':
                        this.rotateImage(actionObject.UndoRedoTileActions[0].currentPageIndex, -90);
                        break;
                    case 'Copy':
                        {
                            const mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject.UndoRedoTileActions[0].
                                currentPageIndex.toString(), 10)];
                            this.insertRemovedPages(actionObject.UndoRedoTileActions[0], actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement);
                            this.tileImageRender(actionObject.UndoRedoTileActions[0].copiedPageIndex, 0, actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement, true, true, false);
                            this.updatePageDetail();
                        }
                        break;
                    case 'Import Pages':
                        {
                            const mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject.UndoRedoTileActions[0].
                                currentPageIndex.toString(), 10)];
                            this.insertRemovedPages(actionObject.UndoRedoTileActions[0], actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement);
                            this.tileImageRender(actionObject.UndoRedoTileActions[0].copiedPageIndex, 0, actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement, true, true, false, true, actionObject.UndoRedoTileActions[0].documentName);
                            this.disableTileCopyRotateButton();
                            this.updatePageDetail();
                        }
                        break;
                    case 'Delete':
                        this.removePage(actionObject.UndoRedoTileActions[0].currentPageIndex);
                        break;
                    case 'Move Pages':
                        this.rearrangePages(actionObject.selectedPagesIndexes, actionObject.dropIndex, actionObject.isRightInsertion);
                        break;
                    case 'Toolbar Rotate Right':
                        this.rotateImages(actionObject, 90);
                        break;
                    case 'Toolbar Rotate Left':
                        this.rotateImages(actionObject, -90);
                        break;
                    case 'Toolbar Copy':
                        {
                            if (actionObject.toolbarActions.length > 0) {
                                for (let i = 0; i < actionObject.toolbarActions.length; i++) {
                                    const mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject.toolbarActions[parseInt(i.toString(), 10)].
                                        currentPageIndex.toString(), 10)];
                                    this.insertRemovedPages(actionObject.toolbarActions[parseInt(i.toString(), 10)], actionObject.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement);
                                    this.tileImageRender(actionObject.toolbarActions[parseInt(i.toString(), 10)].copiedPageIndex, 0, actionObject.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement, true, true, false);
                                    this.updatePageDetail();
                                }
                            }
                            this.disableTileDeleteButton();
                        }
                        break;
                    case 'Toolbar Delete':
                        if (actionObject.toolbarActions.length > 0) {
                            for (let i = actionObject.toolbarActions.length - 1; i >= 0; i--) {
                                const mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject.toolbarActions[parseInt(i.toString(), 10)].
                                    currentPageIndex.toString(), 10)];
                                this.deleteTempPage(actionObject.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement);
                                this.tileAreaDiv.removeChild(mainTileElement);
                                this.updatePageDetail();
                            }
                        }
                        this.disableTileDeleteButton();
                        break;
                }
            }
        };
        /**
         * @private
         * @returns {void}
         */
        this.undo = () => {
            const undoActionObject = this.undoOrganizeCollection.pop();
            this.undoActionHandler(undoActionObject);
            this.redoOrganizeCollection.push(undoActionObject);
            this.enableDisableToolbarItems();
            this.updateUndoRedoButtons();
        };
        /**
         * @private
         * @returns {void}
         */
        this.redo = () => {
            const redoActionObject = this.redoOrganizeCollection.pop();
            this.redoActionHandler(redoActionObject);
            this.undoOrganizeCollection.push(redoActionObject);
            this.enableDisableToolbarItems();
            this.updateUndoRedoButtons();
        };
        this.rotateImages = (actionObject, rotationAngle) => {
            if (actionObject.toolbarActions.length > 0) {
                for (let i = 0; i < actionObject.toolbarActions.length; i++) {
                    const mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject.toolbarActions[parseInt(i.toString(), 10)].
                        currentPageIndex.toString(), 10)];
                    const imageContainer = mainTileElement.querySelector('.e-pv-organize-image');
                    if (imageContainer) {
                        let currentRotation = parseFloat(imageContainer.style.transform.replace('rotate(', '').replace('deg)', '')) || 0;
                        currentRotation = (currentRotation + rotationAngle + 360) % 360;
                        imageContainer.style.transform = `rotate(${currentRotation}deg)`;
                        this.updateTempRotationDetail(actionObject.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, rotationAngle);
                    }
                }
            }
        };
        this.insertRightButtonClick = (event) => {
            if (this.pdfViewer.pageOrganizerSettings.canInsert) {
                const insertRightButton = event.currentTarget;
                const buttonId = insertRightButton.id.split('_insert_page_')[insertRightButton.id.split('_insert_page_').length - 1];
                const mainTileElement = insertRightButton.closest('.e-pv-organize-anchor-node');
                const pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
                const buttonIdlist = buttonId.split('_');
                let subIndex = 0;
                let buttonIndex = parseInt(buttonIdlist[parseInt((buttonIdlist.length - 1).toString(), 10)], 10);
                if (buttonIdlist.length > 1) {
                    buttonIndex = parseInt(buttonIdlist[parseInt((buttonIdlist.length - 2).toString(), 10)], 10);
                }
                subIndex = this.getNextSubIndex(mainTileElement.parentElement, buttonIndex);
                this.insertTempPage(pageOrder, false, mainTileElement);
                this.tileImageRender(buttonIndex, subIndex, pageOrder + 1, mainTileElement, true, false, true);
                this.updateTotalPageCount();
                this.updatePageNumber();
                this.disableTileDeleteButton();
                this.disableTileCopyButton();
                this.updateSelectAllCheckbox();
                this.enableDisableToolbarItems();
                const clonedCollection = [];
                clonedCollection.push(this.clonedCollection(this.tempOrganizePagesCollection.
                    find((item) => { return item.currentPageIndex === (pageOrder + 1); })));
                this.addOrganizeAction(clonedCollection, 'Insert Right', [], [], null, false);
            }
        };
        this.insertLeftButtonClick = (event) => {
            if (this.pdfViewer.pageOrganizerSettings.canInsert) {
                const insetLeftButton = event.currentTarget;
                const buttonId = insetLeftButton.id.split('_insert_page_')[insetLeftButton.id.split('_insert_page_').length - 1];
                const mainTileElement = insetLeftButton.closest('.e-pv-organize-anchor-node');
                const pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
                const buttonIdlist = buttonId.split('_');
                let subIndex = 0;
                let buttonIndex = parseInt(buttonIdlist[parseInt((buttonIdlist.length - 1).toString(), 10)], 10);
                if (buttonIdlist.length > 1) {
                    buttonIndex = parseInt(buttonIdlist[parseInt((buttonIdlist.length - 2).toString(), 10)], 10);
                }
                subIndex = this.getNextSubIndex(mainTileElement.parentElement, buttonIndex);
                this.insertTempPage(pageOrder, true, mainTileElement);
                this.tileImageRender(buttonIndex, subIndex, pageOrder, mainTileElement, true, true, true);
                this.updateTotalPageCount();
                this.updatePageNumber();
                this.disableTileDeleteButton();
                this.disableTileCopyButton();
                this.updateSelectAllCheckbox();
                this.enableDisableToolbarItems();
                const clonedCollection = [];
                clonedCollection.push(this.clonedCollection(this.tempOrganizePagesCollection.
                    find((item) => { return item.currentPageIndex === pageOrder; })));
                this.addOrganizeAction(clonedCollection, 'Insert Left', [], [], null, false);
            }
        };
        this.copyButtonClick = (event) => {
            if (this.pdfViewer.pageOrganizerSettings.canCopy) {
                const copyButton = event.currentTarget;
                const buttonId = copyButton.id.split('_copy_page_')[copyButton.id.split('_copy_page_').length - 1];
                const mainTileElement = copyButton.closest('.e-pv-organize-anchor-node');
                const pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
                const buttonIdlist = buttonId.split('_');
                let subIndex = 0;
                let buttonIndex = parseInt(buttonIdlist[parseInt((buttonIdlist.length - 1).toString(), 10)], 10);
                if (buttonIdlist.length > 1) {
                    buttonIndex = parseInt(buttonIdlist[parseInt((buttonIdlist.length - 2).toString(), 10)], 10);
                }
                subIndex = this.getNextSubIndex(mainTileElement.parentElement, buttonIndex);
                this.copyPage(pageOrder, mainTileElement);
                this.tileImageRender(buttonIndex, subIndex, pageOrder + 1, mainTileElement, true, false, false);
                this.updateTotalPageCount();
                this.updatePageNumber();
                this.disableTileDeleteButton();
                const clonedCollection = [];
                clonedCollection.push(this.clonedCollection(this.tempOrganizePagesCollection.
                    find((item) => { return item.currentPageIndex === (pageOrder + 1); })));
                this.addOrganizeAction(clonedCollection, 'Copy', [], [], null, false);
            }
        };
        this.deleteButtonClick = (event) => {
            if (this.pdfViewer.pageOrganizerSettings.canDelete) {
                const deleteButton = event.currentTarget;
                const mainTileElement = deleteButton.closest('.e-pv-organize-anchor-node');
                const pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
                const clonedCollection = [];
                clonedCollection.push(this.clonedCollection(this.tempOrganizePagesCollection.
                    find((item) => { return item.currentPageIndex === pageOrder; })));
                this.addOrganizeAction(clonedCollection, 'Delete', [], [], null, false);
                this.deletePageElement(mainTileElement);
            }
            this.updateSelectAllCheckbox();
            this.enableDisableToolbarItems();
        };
        this.pdfViewer = pdfViewer;
        this.pdfViewerBase = pdfViewerBase;
        this.setPageOrganizerSettings(this.pdfViewer.pageOrganizerSettings);
        this.currentImageZoom = this.pdfViewer.pageOrganizerSettings.imageZoom;
        this.currentPageZoomSliderValue = this.pdfViewer.pageOrganizerSettings.imageZoom;
        this.previouslyRequestedImageZoom = Math.round(this.pdfViewer.pageOrganizerSettings.imageZoom);
    }
    /**
     * @param {boolean} isReConstruct - It describes about the isReConstruct
     * @private
     * @returns {void}
     */
    createOrganizeWindow(isReConstruct) {
        const elementID = this.pdfViewer.element.id;
        if (!isNullOrUndefined(document.getElementById(elementID + '_organize_window')) && !isNullOrUndefined(this.organizeDialog)) {
            this.organizeDialog.show(true);
            this.isOrganizeWindowOpen = true;
            return;
        }
        this.dialogDivElement = createElement('div', { id: elementID + '_organize_window', className: 'e-pv-organize-window' });
        const dialogDiv = this.dialogDivElement;
        const contentRegion = this.createContentArea();
        this.pdfViewerBase.mainContainer.appendChild(dialogDiv);
        this.organizeDialog = new Dialog({
            showCloseIcon: true,
            closeOnEscape: true,
            isModal: true,
            header: this.pdfViewer.localeObj.getConstant('Organize Pages'),
            target: this.pdfViewerBase.mainContainer,
            content: contentRegion,
            visible: false,
            open: () => {
                this.organizeWindowFocus();
            },
            close: (args) => {
                if (!this.isSkipRevert) {
                    this.tempOrganizePagesCollection = JSON.parse(JSON.stringify(this.organizePagesCollection));
                    this.undoOrganizeCollection = [];
                    this.redoOrganizeCollection = [];
                    this.isDocumentModified = false;
                    this.pdfViewerBase.isImportDoc = false;
                    this.startTile = null;
                    this.ctrlKey = false;
                    this.shiftKey = false;
                    this.isTouchEvent = false;
                    this.isClickedOnCheckBox = false;
                    this.totalCheckedCount = 0;
                    this.isOrganizeWindowOpen = false;
                    this.destroyDialogWindow();
                    this.createOrganizeWindow(true);
                }
                else {
                    this.isSkipRevert = false;
                }
            },
            created: (args) => {
                if (this.pdfViewer.pageOrganizerSettings.showImageZoomingSlider) {
                    this.createPageZoomDropDown();
                }
            }
        });
        if (!Browser.isDevice || this.pdfViewer.enableDesktopMode) {
            const pagecount = this.pdfViewerBase.pageCount;
            this.organizeDialog.buttons = [
                { buttonModel: { content: this.pdfViewer.localeObj.getConstant('Save As'), isPrimary: true }, click: this.onSaveasClicked.bind(this) },
                { buttonModel: { content: this.pdfViewer.localeObj.getConstant('Save'), isPrimary: true }, click: this.onSaveClicked.bind(this) },
                { buttonModel: { content: this.pdfViewer.localeObj.getConstant('Total') + ' ' + pagecount.toString() + ' ' + this.pdfViewer.localeObj.getConstant('Pages'), cssClass: 'e-pv-organize-total-page-button', disabled: true } }
            ];
        }
        // Listen to window resize events to update the dialog size dynamically
        window.addEventListener('resize', () => {
            this.updateOrganizeDialogSize();
        });
        if (this.pdfViewer.enableRtl) {
            this.organizeDialog.enableRtl = true;
        }
        this.waitingPopup = createElement('div', { id: elementID + '_organizeLoadingIndicator' });
        dialogDiv.appendChild(this.waitingPopup);
        createSpinner({ target: this.waitingPopup, cssClass: 'e-spin-center' });
        this.pdfViewerBase.setLoaderProperties(this.waitingPopup);
        this.organizeDialog.appendTo(dialogDiv);
        if (!isReConstruct) {
            this.organizeDialog.show(true);
            this.isOrganizeWindowOpen = true;
        }
        this.disableTileDeleteButton();
        this.enableDisableToolbarItems();
        this.updateUndoRedoButtons();
        this.initEventListeners();
    }
    /**
     * @param {boolean} isReConstruct - Defines whether organizer window is reconstructed when closing
     * @private
     * @returns {void}
     */
    createOrganizeWindowForMobile(isReConstruct) {
        const elementID = this.pdfViewer.element.id;
        if (!isNullOrUndefined(document.getElementById(elementID + '_organize_window')) && !isNullOrUndefined(this.organizeDialog)) {
            this.organizeDialog.show(true);
            this.isOrganizeWindowOpen = true;
            return;
        }
        this.dialogDivElement = createElement('div', { id: elementID + '_organize_window', className: 'e-pv-organize-window' });
        const dialogDiv = this.dialogDivElement;
        const contentRegion = this.createContentArea();
        this.pdfViewerBase.mainContainer.appendChild(dialogDiv);
        this.organizeDialog = new Dialog({
            showCloseIcon: true,
            closeOnEscape: true,
            isModal: true,
            header: this.pdfViewer.localeObj.getConstant('Organize Pages'),
            target: this.pdfViewerBase.mainContainer,
            content: contentRegion,
            visible: false,
            animationSettings: { effect: 'None' },
            created: () => {
                if (this.pdfViewer.pageOrganizerSettings.showImageZoomingSlider) {
                    this.createPageZoomDropDown();
                }
            },
            open: () => {
                this.toolbar.refreshOverflow();
                if (this.pdfViewer.pageOrganizerSettings.showImageZoomingSlider) {
                    this.handlePageZoomPopupMobile();
                }
            },
            close: () => {
                if (!this.isSkipRevert) {
                    this.tempOrganizePagesCollection = JSON.parse(JSON.stringify(this.organizePagesCollection));
                    this.undoOrganizeCollection = [];
                    this.redoOrganizeCollection = [];
                    this.isDocumentModified = false;
                    this.pdfViewerBase.isImportDoc = false;
                    this.startTile = null;
                    this.ctrlKey = false;
                    this.shiftKey = false;
                    this.isTouchEvent = false;
                    this.isClickedOnCheckBox = false;
                    this.isOrganizeWindowOpen = false;
                    this.totalCheckedCount = 0;
                    this.destroyDialogWindow();
                    this.createOrganizeWindowForMobile(true);
                }
                else {
                    this.isSkipRevert = false;
                }
            }
        });
        if (!Browser.isDevice || this.pdfViewer.enableDesktopMode) {
            const pagecount = this.pdfViewerBase.pageCount;
            this.organizeDialog.buttons = [
                { buttonModel: { content: this.pdfViewer.localeObj.getConstant('Save As'), isPrimary: true }, click: this.onSaveasClicked.bind(this) },
                { buttonModel: { content: this.pdfViewer.localeObj.getConstant('Save'), isPrimary: true }, click: this.onSaveClicked.bind(this) },
                { buttonModel: { content: this.pdfViewer.localeObj.getConstant('Total') + ' ' + pagecount.toString() + ' ' + this.pdfViewer.localeObj.getConstant('Pages'), cssClass: 'e-pv-organize-total-page-button', disabled: true } }
            ];
        }
        // Listen to window resize events to update the dialog size dynamically
        window.addEventListener('resize', () => {
            this.updateOrganizeDialogSize();
        });
        if (this.pdfViewer.enableRtl) {
            this.organizeDialog.enableRtl = true;
        }
        this.waitingPopup = createElement('div', { id: elementID + '_organizeLoadingIndicator' });
        dialogDiv.appendChild(this.waitingPopup);
        createSpinner({ target: this.waitingPopup, cssClass: 'e-spin-center' });
        this.pdfViewerBase.setLoaderProperties(this.waitingPopup);
        this.organizeDialog.appendTo(dialogDiv);
        if (!isReConstruct) {
            this.organizeDialog.show(true);
            this.isOrganizeWindowOpen = true;
        }
        this.createMobileContextMenu();
        this.disableTileDeleteButton();
        this.enableDisableToolbarItems();
        this.updateUndoRedoButtons();
        this.initEventListeners();
    }
    /**
     * @private
     * @param {PageOrganizerSettingsModel} pageOrganizerSettings new page organizer settings object
     * @returns {void}
     */
    setPageOrganizerSettings(pageOrganizerSettings) {
        if (!isNullOrUndefined(pageOrganizerSettings)) {
            if (isNullOrUndefined(pageOrganizerSettings.canDelete)) {
                this.pdfViewer.pageOrganizerSettings.canDelete = true;
            }
            if (isNullOrUndefined(pageOrganizerSettings.canRotate)) {
                this.pdfViewer.pageOrganizerSettings.canRotate = true;
            }
            if (isNullOrUndefined(pageOrganizerSettings.canInsert)) {
                this.pdfViewer.pageOrganizerSettings.canInsert = true;
            }
            if (isNullOrUndefined(pageOrganizerSettings.canCopy)) {
                this.pdfViewer.pageOrganizerSettings.canCopy = true;
            }
            if (isNullOrUndefined(pageOrganizerSettings.canRearrange)) {
                this.pdfViewer.pageOrganizerSettings.canRearrange = true;
            }
            if (isNullOrUndefined(pageOrganizerSettings.canImport)) {
                this.pdfViewer.pageOrganizerSettings.canImport = true;
            }
            if (isNullOrUndefined(pageOrganizerSettings.showImageZoomingSlider)) {
                this.pdfViewer.pageOrganizerSettings.showImageZoomingSlider = false;
            }
            if (isNullOrUndefined(pageOrganizerSettings.imageZoomMin)) {
                this.pdfViewer.pageOrganizerSettings.imageZoomMin = 1;
            }
            if (isNullOrUndefined(pageOrganizerSettings.imageZoomMax)) {
                this.pdfViewer.pageOrganizerSettings.imageZoomMax = 5;
            }
            if (this.pdfViewer.pageOrganizerSettings.imageZoomMin >= this.pdfViewer.pageOrganizerSettings.imageZoomMax) {
                this.pdfViewer.pageOrganizerSettings.imageZoomMin = 1;
                this.pdfViewer.pageOrganizerSettings.imageZoomMax = 5;
            }
            if (this.pdfViewer.pageOrganizerSettings.imageZoomMin < 1 || this.pdfViewer.pageOrganizerSettings.imageZoomMin >= 5) {
                this.pdfViewer.pageOrganizerSettings.imageZoomMin = 1;
            }
            if (this.pdfViewer.pageOrganizerSettings.imageZoomMax > 5 || this.pdfViewer.pageOrganizerSettings.imageZoomMax <= 1) {
                this.pdfViewer.pageOrganizerSettings.imageZoomMax = 5;
            }
            const range = this.pdfViewer.pageOrganizerSettings.imageZoomMax - this.pdfViewer.pageOrganizerSettings.imageZoomMin;
            this.pageZoomSliderStep = range / 100;
            if (isNullOrUndefined(pageOrganizerSettings.imageZoom)) {
                this.pdfViewer.pageOrganizerSettings.imageZoom = this.pdfViewer.pageOrganizerSettings.imageZoomMin;
            }
            if (this.pdfViewer.pageOrganizerSettings.imageZoom > this.pdfViewer.pageOrganizerSettings.imageZoomMax) {
                this.pdfViewer.pageOrganizerSettings.imageZoom = this.pdfViewer.pageOrganizerSettings.imageZoomMax;
            }
            else if (this.pdfViewer.pageOrganizerSettings.imageZoom < this.pdfViewer.pageOrganizerSettings.imageZoomMin) {
                this.pdfViewer.pageOrganizerSettings.imageZoom = this.pdfViewer.pageOrganizerSettings.imageZoomMin;
            }
        }
    }
    initEventListeners() {
        this.boundOnTileAreaMouseDown = this.onTileAreaMouseDown.bind(this);
        this.boundOnTileAreaKeyDown = this.onTileAreaKeyDown.bind(this);
        this.boundOnTileAreaKeyUp = this.onTileAreaKeyUp.bind(this);
        this.boundPageOrganizerOnScroll = this.pageOrganizerOnScroll.bind(this);
        this.dialogDivElement.addEventListener('wheel', this.boundPageOrganizerOnScroll);
        this.tileAreaDiv.addEventListener('mousedown', this.boundOnTileAreaMouseDown);
        document.addEventListener('keydown', this.boundOnTileAreaKeyDown);
        document.addEventListener('keyup', this.boundOnTileAreaKeyUp);
    }
    removeEventListeners() {
        if (!isNullOrUndefined(this.dialogDivElement)) {
            this.dialogDivElement.removeEventListener('wheel', this.boundPageOrganizerOnScroll);
        }
        if (!isNullOrUndefined(this.tileAreaDiv)) {
            this.tileAreaDiv.removeEventListener('mousedown', this.boundOnTileAreaMouseDown);
        }
        document.removeEventListener('keydown', this.boundOnTileAreaKeyDown);
        document.removeEventListener('keyup', this.boundOnTileAreaKeyUp);
    }
    pageOrganizerOnScroll(event) {
        if (this.ctrlKey) {
            event.preventDefault();
            const imageZoom = this.getImageZoomValue();
            const imageZoomMin = this.getImageZoomMin();
            const imageZoomMax = this.getImageZoomMax();
            if (event.deltaY < 0 && (imageZoom < imageZoomMax)) {
                if (imageZoom + this.pageZoomSliderStep < imageZoomMax) {
                    this.handlePageZoomChange(imageZoom + this.pageZoomSliderStep, imageZoom);
                }
                else if (imageZoom + this.pageZoomSliderStep > imageZoomMax && imageZoom !== imageZoomMax) {
                    this.handlePageZoomChange(imageZoomMax, imageZoom);
                }
            }
            else if (event.deltaY > 0 && (imageZoom > imageZoomMin)) {
                if (imageZoom - this.pageZoomSliderStep > imageZoomMin) {
                    this.handlePageZoomChange(imageZoom - this.pageZoomSliderStep, imageZoom);
                }
                else if (imageZoom - this.pageZoomSliderStep < imageZoomMin && imageZoom !== imageZoomMin) {
                    this.handlePageZoomChange(imageZoomMin, imageZoom);
                }
            }
        }
    }
    onTileAreaMouseDown(event) {
        if (event.target && event.target.previousElementSibling &&
            event.target.previousElementSibling.classList.contains('e-pv-organize-tile-checkbox')) {
            this.isClickedOnCheckBox = true;
        }
        else {
            this.isClickedOnCheckBox = false;
        }
        if (event.target.closest('.e-pv-organize-anchor-node')) {
            const targetTile = event.target;
            const tiles = Array.from(this.tileAreaDiv.children);
            if (this.shiftKey && this.startTile) {
                // Shift key selection logic
                const currentIndex = Array.from(this.tileAreaDiv.children).indexOf(targetTile.closest('.e-pv-organize-anchor-node'));
                if (this.startTile) {
                    const startIndex = Array.from(this.tileAreaDiv.children).indexOf(this.startTile.closest('.e-pv-organize-anchor-node'));
                    this.selectRange(startIndex, currentIndex);
                    tiles.forEach((tile, index) => {
                        if (index < Math.min(startIndex, currentIndex) || index > Math.max(startIndex, currentIndex)) {
                            this.deselectTile(tile);
                        }
                    });
                }
            }
            else if (!this.ctrlKey) {
                this.startTile = targetTile;
            }
        }
        else {
            if (!this.ctrlKey && !this.shiftKey) {
                this.clearSelection();
                this.startTile = null;
            }
        }
        this.updateSelectAllCheckbox();
        this.enableDisableToolbarItems();
    }
    onTileAreaKeyDown(event) {
        if ((event.ctrlKey || event.metaKey) && !event.shiftKey) {
            this.ctrlKey = true;
            if (this.isOrganizeWindowOpen) {
                if (event.keyCode === 65) {
                    event.preventDefault();
                    this.selectAllTiles();
                }
                if (event.keyCode === 90) {
                    event.preventDefault();
                    this.undo();
                }
                else if (event.keyCode === 89) {
                    event.preventDefault();
                    this.redo();
                }
            }
        }
        if (event.shiftKey) {
            this.shiftKey = true;
        }
    }
    onTileAreaKeyUp(event) {
        if (!(event.ctrlKey || event.metaKey)) {
            this.ctrlKey = false;
        }
        if (!event.shiftKey) {
            this.shiftKey = false;
        }
    }
    onSelectAllClick(event) {
        if (event.checked) {
            this.selectAllTiles();
        }
        else {
            this.clearSelection();
        }
    }
    selectRange(startIndex, endIndex) {
        const minIndex = Math.min(startIndex, endIndex);
        const maxIndex = Math.max(startIndex, endIndex);
        for (let i = minIndex; i <= maxIndex; i++) {
            const tile = this.tileAreaDiv.children[parseInt(i.toString(), 10)];
            this.selectTile(tile);
        }
    }
    selectTile(tile) {
        if (!isNullOrUndefined(tile)) {
            const checkbox = tile.closest('.e-pv-organize-anchor-node').querySelector('.e-pv-organize-tile-checkbox');
            if (checkbox) {
                checkbox.checked = true;
                this.setSelectionRingStyle(checkbox, tile);
            }
        }
    }
    deselectTile(tile) {
        if (!isNullOrUndefined(tile)) {
            const checkbox = tile.closest('.e-pv-organize-anchor-node').querySelector('.e-pv-organize-tile-checkbox');
            if (checkbox) {
                checkbox.checked = false;
                this.setSelectionRingStyle(checkbox, tile);
            }
        }
    }
    clearSelection() {
        const selectedTiles = document.querySelectorAll('.e-pv-organize-node-selection-ring');
        selectedTiles.forEach((tile) => {
            const checkbox = tile.closest('.e-pv-organize-anchor-node').querySelector('.e-pv-organize-tile-checkbox');
            checkbox.checked = false;
            this.setSelectionRingStyle(checkbox, tile);
        });
        this.updateSelectAllCheckbox();
        this.enableDisableToolbarItems();
    }
    selectAllTiles() {
        Array.from(this.tileAreaDiv.children).forEach((tile) => {
            this.selectTile(tile);
        });
        this.updateSelectAllCheckbox();
        this.enableDisableToolbarItems();
    }
    updateOrganizeDialogSize() {
        // Update the dialog size based on the viewer container size
        const dialogWidth = this.pdfViewer.element.getBoundingClientRect().width;
        const dialogHeight = this.pdfViewer.element.getBoundingClientRect().height;
        if (!isNullOrUndefined(this.organizeDialog)) {
            this.organizeDialog.width = `${dialogWidth}px`;
            this.organizeDialog.height = `${dialogHeight}px`;
        }
    }
    createContentArea() {
        const elementID = this.pdfViewer.element.id;
        const contentDiv = createElement('div', { id: elementID + '_content_appearance', className: 'e-pv-organize-content-apperance' });
        const toolbarDiv = createElement('div', { id: elementID + '_toolbar_appearance', className: 'e-pv-organize-toolbar-apperance' });
        this.tileAreaWrapper = createElement('div', { id: this.pdfViewer.element.id + '_organize_tile_view_wrapper', className: 'e-pv-organize-tile-view-wrapper' });
        this.tileAreaDiv = createElement('div', { id: this.pdfViewer.element.id + '_organize_tile_view', className: 'e-pv-organize-tile-view e-pv-thumbnail-row' });
        this.tileAreaWrapper.style.width = '100%';
        this.tileAreaWrapper.style.height = 'calc(100% - 48px)';
        this.tileAreaWrapper.style.position = 'relative';
        contentDiv.style.width = '100%';
        contentDiv.style.height = '100%';
        toolbarDiv.style.height = '48px';
        this.tileAreaDiv.style.height = '100%';
        this.selectAllCheckBox = new CheckBox({ label: Browser.isDevice && !this.pdfViewer.enableDesktopMode ? '' : this.pdfViewer.localeObj.getConstant('Select All'), cssClass: 'e-pv-organize-select-all', checked: false, change: this.onSelectAllClick.bind(this) });
        const toolbarItems = [];
        const toolbarItemsForDesktop = [
            { type: 'Input', template: this.selectAllCheckBox, id: 'selectAllCheckbox', align: 'Left' },
            { type: 'Separator', align: 'Left' },
            {
                prefixIcon: 'e-pv-undo-icon e-pv-icon', visible: true, cssClass: 'e-pv-undo-container', id: this.pdfViewer.element.id + '_undo_organize_Pages', align: 'Left', click: (args) => {
                    this.undo();
                }
            },
            {
                prefixIcon: 'e-pv-redo-icon e-pv-icon', visible: true, cssClass: 'e-pv-redo-container', id: this.pdfViewer.element.id + '_redo_organize_Pages', align: 'Left', click: (args) => {
                    this.redo();
                }
            },
            {
                prefixIcon: 'e-pv-rotate-left-icon e-pv-icon', visible: true, cssClass: 'e-pv-toolbar-rotate-left', id: this.pdfViewer.element.id + '_rotate_page_left', align: 'Center', click: (args) => {
                    this.onToolbarLeftButtonClick();
                }
            },
            {
                prefixIcon: 'e-pv-rotate-right-icon e-pv-icon', visible: true, cssClass: 'e-pv-toolbar-rotate-right', id: this.pdfViewer.element.id + '_rotate_page_right', align: 'Center', click: (args) => {
                    this.onToolbarRightButtonClick();
                }
            },
            { type: 'Separator', align: 'Center' },
            { prefixIcon: 'e-pv-copy-icon e-pv-icon', visible: true, cssClass: 'e-pv-toolbar-rotate-right', id: this.pdfViewer.element.id + '_copy_page', align: 'Center', click: (args) => {
                    this.onToolbarCopyButtonClick();
                } },
            { type: 'Separator', align: 'Center' },
            {
                prefixIcon: 'e-pv-delete-icon e-pv-icon', visible: true, cssClass: 'e-pv-delete-selected', id: this.pdfViewer.element.id + '_delete_selected', align: 'Center', click: (args) => {
                    this.onToolbarDeleteButtonClick();
                }
            },
            {
                prefixIcon: 'e-pv-import-icon e-pv-icon', text: this.pdfViewer.localeObj.getConstant('Import Document'), visible: true, cssClass: 'e-pv-import-pages', id: this.pdfViewer.element.id + '_import_pages', align: 'Right', click: (args) => {
                    this.bindImportDocEvent();
                }
            }
        ];
        if (this.pdfViewer.pageOrganizerSettings.showImageZoomingSlider) {
            this.addPageZoomDropDown(true, toolbarItemsForDesktop);
        }
        const toolbarItemsForMobile = [
            { type: 'Input', template: this.selectAllCheckBox, id: 'selectAllCheckbox', align: 'Left' },
            { type: 'Separator', align: 'Left' },
            {
                prefixIcon: 'e-pv-undo-icon e-pv-icon', visible: true, cssClass: 'e-pv-undo-container', id: this.pdfViewer.element.id + '_undo_organize_Pages', align: 'Left', click: (args) => {
                    this.undo();
                }
            },
            {
                prefixIcon: 'e-pv-redo-icon e-pv-icon', visible: true, cssClass: 'e-pv-redo-container', id: this.pdfViewer.element.id + '_redo_organize_Pages', align: 'Left', click: (args) => {
                    this.redo();
                }
            },
            {
                prefixIcon: 'e-pv-rotate-left-icon e-pv-icon', visible: true, cssClass: 'e-pv-toolbar-rotate-left', id: this.pdfViewer.element.id + '_rotate_page_left', align: 'Right', click: (args) => {
                    this.onToolbarLeftButtonClick();
                }
            },
            {
                prefixIcon: 'e-pv-rotate-right-icon e-pv-icon', visible: true, cssClass: 'e-pv-toolbar-rotate-right', id: this.pdfViewer.element.id + '_rotate_page_right', align: 'Right', click: (args) => {
                    this.onToolbarRightButtonClick();
                }
            },
            {
                prefixIcon: 'e-pv-delete-icon e-pv-icon', visible: true, cssClass: 'e-pv-delete-selected', id: this.pdfViewer.element.id + '_delete_selected', align: 'Right', click: (args) => {
                    this.onToolbarDeleteButtonClick();
                }
            },
            { type: 'Separator', align: 'Right' },
            {
                prefixIcon: 'e-pv-more-icon e-pv-icon', visible: true, cssClass: 'e-pv-toolbar-rotate-right', id: this.pdfViewer.element.id + '_organize_more_button', align: 'Right',
                click: this.openContextMenu.bind(this)
            }
        ];
        if (this.pdfViewer.pageOrganizerSettings.showImageZoomingSlider) {
            this.addPageZoomDropDown(true, toolbarItemsForMobile);
        }
        if (Browser.isDevice && !this.pdfViewer.enableDesktopMode) {
            toolbarItems.push(...toolbarItemsForMobile);
        }
        else {
            toolbarItems.push(...toolbarItemsForDesktop);
        }
        this.toolbar = new Toolbar({
            items: toolbarItems
        });
        this.toolbar.cssClass = 'e-pv-organize-toolbar';
        this.toolbar.height = '48px';
        this.toolbar.width = 'auto';
        if (Browser.isDevice && !this.pdfViewer.enableDesktopMode) {
            this.toolbar.overflowMode = 'Popup';
        }
        this.toolbar.appendTo(toolbarDiv);
        contentDiv.appendChild(toolbarDiv);
        this.renderThumbnailImage();
        this.tileAreaWrapper.appendChild(this.tileAreaDiv);
        contentDiv.appendChild(this.tileAreaWrapper);
        this.createImportDocElement(toolbarDiv);
        this.organizeWireEvent();
        const rotateRightToolbarButton = toolbarDiv.querySelector('#' + this.pdfViewer.element.id + '_rotate_page_right');
        if (!isNullOrUndefined(rotateRightToolbarButton)) {
            this.createTooltip(rotateRightToolbarButton, this.pdfViewer.localeObj.getConstant('Rotate Right'));
        }
        const rotateLeftToolbarButton = toolbarDiv.querySelector('#' + this.pdfViewer.element.id + '_rotate_page_left');
        if (!isNullOrUndefined(rotateLeftToolbarButton)) {
            this.createTooltip(rotateLeftToolbarButton, this.pdfViewer.localeObj.getConstant('Rotate Left'));
        }
        const copyToolbarButton = toolbarDiv.querySelector('#' + this.pdfViewer.element.id + '_copy_page');
        if (!isNullOrUndefined(copyToolbarButton)) {
            this.createTooltip(copyToolbarButton, this.pdfViewer.localeObj.getConstant('Copy Pages'));
        }
        const deleteToolbarButton = toolbarDiv.querySelector('#' + this.pdfViewer.element.id + '_delete_selected');
        if (!isNullOrUndefined(deleteToolbarButton)) {
            this.createTooltip(deleteToolbarButton, this.pdfViewer.localeObj.getConstant('Delete Pages'));
        }
        const undoToolbarButton = toolbarDiv.querySelector('#' + this.pdfViewer.element.id + '_undo_organize_Pages');
        if (!isNullOrUndefined(undoToolbarButton)) {
            this.createTooltip(undoToolbarButton, this.pdfViewer.localeObj.getConstant('Undo'));
        }
        const redoToolbarButton = toolbarDiv.querySelector('#' + this.pdfViewer.element.id + '_redo_organize_Pages');
        if (!isNullOrUndefined(redoToolbarButton)) {
            this.createTooltip(redoToolbarButton, this.pdfViewer.localeObj.getConstant('Redo'));
        }
        return contentDiv;
    }
    updatePageZoomPopup() {
        if (this.isPageZoomPopupOpen && (this.pageZoomSlider.value !== this.currentPageZoomSliderValue)) {
            this.pageZoomSlider.value = this.currentPageZoomSliderValue;
            this.pageZoomSlider.reposition();
        }
        this.handlePageZoomButtonsVisibility(this.currentPageZoomSliderValue);
    }
    getImageZoomMin() {
        let currentMinSize = this.pdfViewer.pageOrganizerSettings.imageZoomMin;
        if (isNullOrUndefined(currentMinSize)) {
            this.pdfViewer.pageOrganizerSettings.imageZoomMin = 1;
            currentMinSize = 1;
        }
        const possibleMinSize = 1;
        if (!Number.isInteger(currentMinSize)) {
            currentMinSize = Math.floor(currentMinSize);
            this.pdfViewer.pageOrganizerSettings.imageZoomMin = currentMinSize;
        }
        if (currentMinSize < possibleMinSize) {
            this.pdfViewer.pageOrganizerSettings.imageZoomMin = possibleMinSize;
        }
        return this.pdfViewer.pageOrganizerSettings.imageZoomMin;
    }
    getImageZoomMax() {
        let currentMaxSize = this.pdfViewer.pageOrganizerSettings.imageZoomMax;
        if (isNullOrUndefined(currentMaxSize)) {
            this.pdfViewer.pageOrganizerSettings.imageZoomMax = 5;
            currentMaxSize = 5;
        }
        const possibleMaxSize = 5;
        if (!Number.isInteger(currentMaxSize)) {
            currentMaxSize = Math.floor(currentMaxSize);
            this.pdfViewer.pageOrganizerSettings.imageZoomMax = currentMaxSize;
        }
        if (currentMaxSize > possibleMaxSize) {
            this.pdfViewer.pageOrganizerSettings.imageZoomMax = possibleMaxSize;
        }
        return this.pdfViewer.pageOrganizerSettings.imageZoomMax;
    }
    isOrganizeDialogRendered() {
        if (!isNullOrUndefined(document.getElementById(this.pdfViewer.element.id + '_organize_window')) && !isNullOrUndefined(this.organizeDialog)) {
            return true;
        }
        return false;
    }
    modifyThumbnailContainer() {
        /* eslint-disable security/detect-object-injection */
        const organizeNodes = this.tileAreaDiv.children;
        const imageSizeFactor = this.getImageZoomFactor(organizeNodes[0].cloneNode(true));
        for (let index = 0; index < organizeNodes.length; index++) {
            const imageContainer = organizeNodes[index];
            imageContainer.style.width = 140 * imageSizeFactor + 'px';
            imageContainer.style.height = 140 * imageSizeFactor + 'px';
            this.blurImageContainer(true, imageContainer);
        }
        /* eslint-enable security/detect-object-injection */
    }
    setThumbnailImage() {
        /* eslint-disable security/detect-object-injection */
        const organizeNodes = this.tileAreaDiv.children;
        for (let index = 0; index < organizeNodes.length; index++) {
            const imageContainer = organizeNodes[index];
            const imageElement = imageContainer.querySelector('.e-pv-organize-image');
            imageElement.src = this.dataDetails[parseInt(index.toString(), 10)].image;
            this.blurImageContainer(false, imageContainer);
        }
        /* eslint-enable security/detect-object-injection */
    }
    handlePageZoomPopupMobile() {
        const pageZoomButton = this.pdfViewerBase.getElement('_page_zoom');
        if (pageZoomButton && pageZoomButton.parentElement.classList.contains('e-toolbar-popup')) {
            pageZoomButton.children[0].style.padding = '0 5px';
            pageZoomButton.children[0].style.minWidth = '0';
        }
    }
    addPageZoomDropDown(isInitialCreation, toolbarItems) {
        if (isInitialCreation) {
            if (Browser.isDevice && !this.pdfViewer.enableDesktopMode) {
                const insertIndex = toolbarItems.findIndex((item) => item.id === this.pdfViewer.element.id + '_organize_more_button');
                toolbarItems.splice(insertIndex - 1, 0, 
                // eslint-disable-next-line @typescript-eslint/indent
                { visible: true, cssClass: 'e-pv-page-zoom', id: this.pdfViewer.element.id + '_page_zoom', align: 'Right' });
            }
            else {
                const insertIndex = toolbarItems.findIndex((item) => item.cssClass === 'e-pv-import-pages');
                toolbarItems.splice(insertIndex, 0, { type: 'Separator', align: 'Center' }, 
                // eslint-disable-next-line @typescript-eslint/indent
                { visible: true, cssClass: 'e-pv-page-zoom', id: this.pdfViewer.element.id + '_page_zoom', align: 'Center' });
            }
        }
        else {
            if (Browser.isDevice && !this.pdfViewer.enableDesktopMode) {
                const insertIndex = this.toolbar.items.findIndex((item) => item.id === this.pdfViewer.element.id + '_page_zoom');
                if (insertIndex !== -1) {
                    this.toolbar.hideItem(this.pdfViewerBase.getElement('_page_zoom').parentElement, false);
                }
            }
            else {
                const insertIndex = this.toolbar.items.findIndex((item) => item.cssClass === 'e-pv-import-pages');
                if (this.toolbar.items[insertIndex - 1].type !== 'Separator') {
                    this.toolbar.addItems([{ type: 'Separator', align: 'Center' },
                        { visible: true, cssClass: 'e-pv-page-zoom', id: this.pdfViewer.element.id + '_page_zoom', align: 'Center' }], insertIndex);
                }
                else {
                    this.toolbar
                        .addItems([{ visible: true, cssClass: 'e-pv-page-zoom', id: this.pdfViewer.element.id + '_page_zoom', align: 'Center' }], insertIndex);
                }
            }
            // Removes the margin left or margin right property of center group in page organizer toolbar
            this.toolbar.element.children[0].children[1].removeAttribute('style');
        }
    }
    createPageZoomDropDown() {
        this.pageZoomElement = this.pdfViewerBase.getElement('_page_zoom');
        this.pageZoomContainer = this.createPageZoomSlider(this.pageZoomElement.id);
        const dropDownButton = new DropDownButton({ iconCss: 'e-pv-page-zoom-icon' + ' e-pv-icon e-icons', target: this.pageZoomContainer });
        if (this.pdfViewer.enableRtl) {
            dropDownButton.enableRtl = true;
        }
        dropDownButton.appendTo(this.pageZoomElement);
        this.createTooltip(this.pageZoomElement, this.pdfViewer.localeObj.getConstant('Change Page Zoom'));
        this.pageZoomElement.setAttribute('aria-label', this.pdfViewer.localeObj.getConstant('Change Page Zoom'));
        this.pageZoomDropDown = dropDownButton;
        this.pageZoomWireEvents();
        this.pageZoomSliderWireEvents();
    }
    shrinkElement(element) {
        const pdfViewerRect = this.pdfViewer.element.getBoundingClientRect();
        const actualWidth = element.clientWidth;
        const decreasePercent = (actualWidth - pdfViewerRect.width) / actualWidth;
        const newHeight = element.clientHeight * (1 - decreasePercent);
        const newWidth = actualWidth * (1 - decreasePercent);
        element.style.width = newWidth + 'px';
        element.style.height = newHeight + 'px';
    }
    pageZoomDropDownOpen(args) {
        if (Browser.isDevice && !this.pdfViewer.enableDesktopMode) {
            const pageZoomButton = this.pdfViewerBase.getElement('_page_zoom');
            args.element.parentElement.style.left = '0px';
            if (args.element.parentElement.clientWidth > this.pdfViewer.element.getBoundingClientRect().width) {
                this.shrinkElement(args.element.parentElement);
            }
            const pageZoomContainerRect = args.element.parentElement.getBoundingClientRect();
            if (pageZoomButton && pageZoomButton.parentElement.classList.contains('e-toolbar-popup')) {
                args.element.parentElement.style.left = (this.pdfViewer.element.getBoundingClientRect().left +
                    // eslint-disable-next-line @typescript-eslint/indent
                    Math.max(((this.pdfViewer.element.getBoundingClientRect().width - pageZoomContainerRect.width) / 2), 0)) + 'px';
            }
            else {
                const pageZoomButtonRect = pageZoomButton.getBoundingClientRect();
                args.element.parentElement.style.left = Math.max((pageZoomButtonRect.right - pageZoomContainerRect.width), 
                // eslint-disable-next-line @typescript-eslint/indent
                this.pdfViewer.element.getBoundingClientRect().left) + 'px';
            }
            args.element.parentElement.style.top = this.pdfViewerBase.getElement('_toolbar_appearance').getBoundingClientRect().bottom + 'px';
        }
        else {
            if (args.element && args.element.parentElement) {
                const leftValue = parseFloat(args.element.parentElement.style.left);
                const width = args.element.parentElement.offsetWidth;
                if ((leftValue + width) > (this.pdfViewer.element.getBoundingClientRect().left +
                    this.pdfViewer.element.offsetWidth + 10)) {
                    args.element.parentElement.style.left = (leftValue - width) + 'px';
                }
            }
        }
        this.isPageZoomPopupOpen = true;
        this.updatePageZoomPopup();
        requestAnimationFrame(() => {
            if (this.pageZoomDecreaseButton.disabled) {
                this.pageZoomSlider.element.querySelector('.e-handle').focus();
            }
            else {
                this.pageZoomDecreaseButton.focus();
            }
        });
    }
    pageZoomDropDownClose() {
        requestAnimationFrame(() => {
            this.pageZoomDropDown.focusIn();
        });
        this.isPageZoomPopupOpen = false;
    }
    pageZoomChange(args) {
        if (args.isInteracted && args.previousValue !== args.value) {
            this.pageZoomSlider.element.querySelector('.e-handle').classList.remove('e-large-thumb-size');
            this.handlePageZoomChange(args.value, args.previousValue);
        }
    }
    blurImageContainer(canBlur, container) {
        if (!isNullOrUndefined(container)) {
            container.style.filter = canBlur ? 'blur(5px)' : '';
        }
    }
    createPageZoomSlider(idString) {
        const outerContainer = createElement('div', { className: 'e-pv-page-zoom-popup-container' });
        document.body.appendChild(outerContainer);
        this.pageZoomDecreaseButton = createElement('button', { id: idString + '_decrease', attrs: { 'aria-label': this.pdfViewer.localeObj.getConstant('Decrease Page Zoom'), 'tabindex': '0' } });
        this.pageZoomDecreaseButton.className = 'e-btn e-pv-page-zoom-decrease e-flat';
        this.pageZoomDecreaseButton.setAttribute('type', 'button');
        const pageZoomDecreaseButtonSpan = createElement('span', { id: idString + '_decrease_icon',
            className: 'e-pv-page-zoom-decrease-icon e-btn-icon e-icons e-pv-icon' });
        this.pageZoomDecreaseButton.appendChild(pageZoomDecreaseButtonSpan);
        this.pageZoomIncreaseButton = createElement('button', { id: idString + '_increase', attrs: { 'aria-label': this.pdfViewer.localeObj.getConstant('Increase Page Zoom'), 'tabindex': '0' } });
        this.pageZoomIncreaseButton.className = 'e-btn e-pv-page-zoom-increase e-flat';
        this.pageZoomIncreaseButton.setAttribute('type', 'button');
        const pageZoomIncreaseButtonSpan = createElement('span', { id: idString + '_decrease_icon',
            className: 'e-pv-page-zoom-increase-icon e-btn-icon e-icons e-pv-icon' });
        this.pageZoomIncreaseButton.appendChild(pageZoomIncreaseButtonSpan);
        const sliderElement = createElement('div', { id: idString + '_slider' });
        this.pageZoomSlider = new Slider({ type: 'MinRange', cssClass: 'e-pv-page-zoom-slider', max: this.getImageZoomMax(), min: this.getImageZoomMin(), step: this.pageZoomSliderStep });
        if (!this.pdfViewer.enableRtl) {
            outerContainer.appendChild(this.pageZoomDecreaseButton);
            outerContainer.appendChild(sliderElement);
            this.pageZoomSlider.appendTo(sliderElement);
            outerContainer.appendChild(this.pageZoomIncreaseButton);
        }
        else {
            outerContainer.appendChild(this.pageZoomIncreaseButton);
            outerContainer.appendChild(sliderElement);
            this.pageZoomSlider.enableRtl = true;
            this.pageZoomSlider.appendTo(sliderElement);
            outerContainer.appendChild(this.pageZoomDecreaseButton);
        }
        this.pageZoomSlider.element.parentElement.classList.add('e-pv-page-zoom-slider-container');
        return outerContainer;
    }
    createMobileContextMenu() {
        this.mobileContextMenu = [
            { text: this.pdfViewer.localeObj.getConstant('Save'), iconCss: 'e-icons e-pv-save-icon e-pv-icon' },
            { text: this.pdfViewer.localeObj.getConstant('Save As'), iconCss: 'e-icons e-pv-save-as-icon e-pv-icon' },
            {
                separator: true
            },
            { text: this.pdfViewer.localeObj.getConstant('Copy'), iconCss: 'e-pv-copy-icon e-pv-icon' },
            {
                separator: true
            },
            { text: this.pdfViewer.localeObj.getConstant('Import Document'), id: this.pdfViewer.element.id + '_import_pages', iconCss: 'e-pv-import-icon e-pv-icon' }
        ];
        const contextMenuElement = createElement('ul', { id: this.pdfViewer.element.id + '_organize_context_menu' });
        this.pdfViewer.element.appendChild(contextMenuElement);
        if (isNullOrUndefined(this.contextMenuObj)) {
            this.contextMenuObj = new ContextMenu({
                target: '#' + this.pdfViewer.element.id + '_organize_more_button', items: this.mobileContextMenu,
                beforeOpen: this.contextMenuBeforeOpen.bind(this),
                select: this.contextMenuItemSelect.bind(this)
            });
            if (this.pdfViewer.enableRtl) {
                this.contextMenuObj.enableRtl = true;
            }
            this.contextMenuObj.appendTo(contextMenuElement);
        }
        if (Browser.isDevice && !this.pdfViewer.enableDesktopMode) {
            this.contextMenuObj.animationSettings.effect = 'ZoomIn';
        }
        else {
            this.contextMenuObj.animationSettings.effect = 'SlideDown';
        }
    }
    contextMenuBeforeOpen(args) {
        this.contextMenuObj.enableItems(['Save', 'Save As'], true);
        this.contextMenuObj.enableItems(['Copy'], false);
        this.contextMenuObj.enableItems(['Import Document'], true);
        const isCopyDisabled = false;
        const isCopyRotateDisabled = false;
        if ((this.selectAllCheckBox.checked || this.selectAllCheckBox.indeterminate) &&
            this.pdfViewer.pageOrganizerSettings.canCopy && !this.getCopiedItems(isCopyDisabled) &&
            !this.getImportedItems(isCopyRotateDisabled)) {
            this.contextMenuObj.enableItems(['Copy'], true);
        }
    }
    getCopiedItems(isCopyDisabled) {
        const selectedNodes = this.tileAreaDiv.querySelectorAll('.e-pv-organize-node-selection-ring');
        selectedNodes.forEach((selectedElements) => {
            const mainTileElement = selectedElements.closest('.e-pv-organize-anchor-node');
            const pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
            const currentPageDetails = this.tempOrganizePagesCollection.
                find((item) => { return item.currentPageIndex === pageOrder; });
            if (currentPageDetails.isInserted && !currentPageDetails.isDeleted) {
                isCopyDisabled = true;
            }
        });
        return isCopyDisabled;
    }
    getImportedItems(isCopyRotateDisabled) {
        const selectedNodes = this.tileAreaDiv.querySelectorAll('.e-pv-organize-node-selection-ring');
        selectedNodes.forEach((selectedElements) => {
            const mainTileElement = selectedElements.closest('.e-pv-organize-anchor-node');
            const pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
            const currentPageDetails = this.tempOrganizePagesCollection.
                find((item) => { return item.currentPageIndex === pageOrder; });
            if (currentPageDetails.isImportedDoc && !currentPageDetails.isDeleted) {
                isCopyRotateDisabled = true;
            }
        });
        return isCopyRotateDisabled;
    }
    contextMenuItemSelect(args) {
        switch (args.item.text) {
            case 'Save':
                this.onSaveClicked();
                break;
            case 'Save As':
                this.onSaveasClicked();
                break;
            case 'Copy':
                this.onToolbarCopyButtonClick();
                break;
            case 'Import Document':
                this.bindImportDocEvent();
                break;
            default:
                break;
        }
    }
    /**
     * @private
     * @returns {void}
     */
    createRequestForPreview() {
        // eslint-disable-next-line
        const proxy = this;
        const isIE = !!document.documentMode;
        if (!isIE) {
            return new Promise(function (renderPreviewImage, reject) {
                proxy.requestPreviewCreation(proxy);
            });
        }
        else {
            this.requestPreviewCreation(proxy);
            return null;
        }
    }
    requestPreviewCreation(proxy) {
        // Removed the condition to skip multiple request for thumbnail image.
        const startIndex = this.lastRequestedPageIndex;
        const endIndex = (startIndex + this.previewLimit) >= this.pdfViewer.pageCount ?
            this.pdfViewer.pageCount : (startIndex + this.previewLimit);
        let digitalSignaturePresent = false;
        for (let i = startIndex; i < endIndex; i++) {
            if (proxy.pdfViewerBase.digitalSignaturePresent(i)) {
                digitalSignaturePresent = true;
            }
        }
        let digitalSignatureList = '';
        if (digitalSignaturePresent) {
            digitalSignatureList = proxy.pdfViewerBase.digitalSignaturePages.toString();
        }
        const jsonObject = { startPage: startIndex.toString(), endPage: endIndex.toString(), sizeX: '99.7', sizeY: '141', hashId: proxy.pdfViewerBase.hashId, action: 'RenderThumbnailImages', elementId: proxy.pdfViewer.element.id, uniqueId: proxy.pdfViewerBase.documentId, digitalSignaturePresent: digitalSignaturePresent, digitalSignaturePageList: digitalSignatureList };
        if (this.pdfViewerBase.jsonDocumentId) {
            jsonObject.documentId = this.pdfViewerBase.jsonDocumentId;
        }
        if (!this.pdfViewerBase.clientSideRendering) {
            const imageSize = this.previouslyRequestedImageZoom;
            jsonObject.imageSize = imageSize;
            jsonObject.initialLoad = this.isInitialLoading;
            this.previewRequestHandler = new AjaxHandler(this.pdfViewer);
            this.previewRequestHandler.url = proxy.pdfViewer.serviceUrl + '/' + proxy.pdfViewer.serverActionSettings.renderThumbnail;
            this.previewRequestHandler.responseType = 'json';
            if (endIndex > 0 && !isNullOrUndefined(proxy.pdfViewerBase.hashId) && !this.isAllImagesReceived) {
                this.previewRequestHandler.send(jsonObject);
            }
            this.previewRequestHandler.onSuccess = function (result) {
                const data = result.data;
                const redirect = proxy.pdfViewerBase.checkRedirection(data);
                if (!redirect) {
                    proxy.updatePreviewCollection(data);
                }
            };
            this.previewRequestHandler.onFailure = function (result) {
                proxy.pdfViewer.fireAjaxRequestFailed(result.status, result.statusText, proxy.pdfViewer.serverActionSettings.renderThumbnail);
            };
            this.previewRequestHandler.onError = function (result) {
                proxy.pdfViewerBase.openNotificationPopup();
                proxy.pdfViewer.fireAjaxRequestFailed(result.status, result.statusText, proxy.pdfViewer.serverActionSettings.renderThumbnail);
            };
        }
        else {
            const start = 0;
            const limit = this.pdfViewer.pageCount;
            const jsonObject = { documentId: proxy.pdfViewerBase.getDocumentId(), hashId: proxy.pdfViewerBase.hashId,
                elementId: proxy.pdfViewer.element.id, uniqueId: proxy.pdfViewerBase.documentId };
            const isTextNeed = proxy.pdfViewer.textSearch ? true : false;
            const initialLoad = this.isInitialLoading;
            const imageSize = proxy.getImageZoomValue(true);
            for (let pageIndex = start; pageIndex < limit; pageIndex++) {
                /* eslint-disable security/detect-object-injection */
                if (!isNullOrUndefined(this.dataDetails[pageIndex] &&
                    this.dataDetails[pageIndex].imageSize === imageSize)) {
                    continue;
                }
                /* eslint-enable security/detect-object-injection */
                this.pdfViewerBase.pdfViewerRunner.addTask({
                    startIndex: start,
                    endIndex: limit,
                    pageIndex: pageIndex,
                    message: 'renderPreviewTileImage',
                    isTextNeed: isTextNeed,
                    jsonObject: jsonObject,
                    isRenderText: isTextNeed,
                    requestType: isTextNeed ? 'pdfTextSearchRequest' : '',
                    imageSize: imageSize,
                    initialLoad: initialLoad
                }, TaskPriorityLevel.Medium);
            }
        }
    }
    /**
     * @param {any} data - It describes about the data
     * @private
     * @returns {void}
     */
    updatePreviewCollection(data) {
        if (data) {
            // eslint-disable-next-line
            const proxy = this;
            if (typeof data !== 'object') {
                try {
                    data = JSON.parse(data);
                }
                catch (error) {
                    proxy.pdfViewerBase.onControlError(500, data, proxy.pdfViewer.serverActionSettings.renderThumbnail);
                    data = null;
                }
            }
            if (data && data.uniqueId === proxy.pdfViewerBase.documentId) {
                proxy.pdfViewer.fireAjaxRequestSuccess(proxy.pdfViewer.serverActionSettings.renderThumbnail, data);
                this.getData(data, proxy.pdfViewerBase.clientSideRendering);
            }
        }
    }
    /**
     * @param {any} event - It describes about the event
     * @private
     * @returns {void}
     */
    previewOnMessage(event) {
        if (event.data.message === 'renderPreviewTileImage') {
            const canvas = document.createElement('canvas');
            const { value, width, height, pageIndex, startIndex, endIndex, imageSize } = event.data;
            canvas.width = width;
            canvas.height = height;
            const canvasContext = canvas.getContext('2d');
            const imageData = canvasContext.createImageData(width, height);
            imageData.data.set(value);
            canvasContext.putImageData(imageData, 0, 0);
            const imageUrl = canvas.toDataURL();
            this.pdfViewerBase.releaseCanvas(canvas);
            const data = ({
                thumbnailImage: imageUrl,
                startPage: startIndex,
                endPage: endIndex,
                uniqueId: this.pdfViewerBase.documentId,
                pageIndex: pageIndex,
                imageSize: imageSize
            });
            this.updatePreviewCollection(data);
        }
    }
    /**
     * @param {any} data - It describes about the data
     * @param {boolean} isClientRender - It describes about the isClientRender
     * @private
     * @returns {void}
     */
    getData(data, isClientRender) {
        if (!this.dataDetails) {
            this.dataDetails = [];
        }
        if (data.imageSize !== this.previouslyRequestedImageZoom) {
            return;
        }
        if (this.dataDetails.length === this.pdfViewer.pageCount) {
            return;
        }
        if (isClientRender) {
            this.dataDetails.push({ pageId: data.pageIndex, image: data.thumbnailImage, imageSize: data.imageSize });
        }
        else {
            const startPage = data.startPage;
            const endPage = data.endPage;
            for (let i = startPage; i < endPage; i++) {
                const thumbnailImage = data.thumbnailImage[parseInt(i.toString(), 10)];
                const pageId = i;
                this.dataDetails.push({ pageId: pageId, image: thumbnailImage, imageSize: data.imageSize });
            }
        }
        this.dataDetails.sort((a, b) => a.pageId - b.pageId);
        if (this.dataDetails.length === this.pdfViewer.pageCount) {
            if (!isNullOrUndefined(this.pdfViewerBase.navigationPane)) {
                this.pdfViewerBase.navigationPane.enableOrganizeButton(true);
            }
            if (!isNullOrUndefined(this.pdfViewer.toolbar)) {
                this.pdfViewer.toolbar.enableToolbarItem(['OrganizePagesTool'], true);
            }
            if (this.isInitialLoading && this.pdfViewer.isPageOrganizerOpen) {
                if (!Browser.isDevice || this.pdfViewer.enableDesktopMode) {
                    this.createOrganizeWindow();
                }
                else {
                    this.createOrganizeWindowForMobile();
                }
            }
            if (this.isPageZoomChanged) {
                if (this.isOrganizeWindowOpen || this.isOrganizeDialogRendered()) {
                    this.restorePagesBeforeZoom();
                    this.setThumbnailImage();
                    this.restorePagesAfterZoom();
                }
                if (this.isOrganizeWindowOpen) {
                    this.showOrganizeLoadingIndicator(false);
                }
                this.isPageZoomChanged = false;
                this.currentImageZoom = this.getImageZoomValue();
                if (this.previousImageZoom !== this.currentImageZoom) {
                    this.pdfViewer.firePageOrganizerZoomChanged(this.previousImageZoom, this.currentImageZoom);
                }
            }
            this.isAllImagesReceived = true;
            this.isInitialLoading = false;
            this.lastRequestedPageIndex = 0;
        }
        else {
            if (!this.pdfViewerBase.clientSideRendering) {
                if (!this.isInitialLoading || (Browser.isDevice && !this.pdfViewer.enableDesktopMode)) {
                    this.lastRequestedPageIndex = parseInt(data.endPage, 10);
                    const isIE = !!document.documentMode;
                    if (!isIE) {
                        Promise.all([this.createRequestForPreview()]);
                    }
                    else {
                        this.createRequestForPreview();
                    }
                }
            }
        }
    }
    createImportDocElement(toolbarElement) {
        if (this.pdfViewer.pageOrganizerSettings.canImport) {
            if (toolbarElement) {
                this.importDocInputElement = createElement('input', { id: this.pdfViewer.element.id + '_importDocElement', styles: 'position:fixed; left:-100em', attrs: { 'type': 'file' } });
                this.importDocInputElement.setAttribute('accept', '.pdf');
                this.importDocInputElement.setAttribute('aria-label', 'import document element');
                this.importDocInputElement.setAttribute('tabindex', '-1');
                toolbarElement.appendChild(this.importDocInputElement);
            }
        }
    }
    movePDFpages(selectedPagesIndexes, dropIndex, isRightInsertion) {
        // Checking if the dropIndex is equal to any of the selected pages indexes
        let isDropIndexSelected = false;
        for (const index of selectedPagesIndexes) {
            if (index === dropIndex) {
                isDropIndexSelected = true;
                break;
            }
        }
        // If the dropIndex is one of the selected pages, return early
        if (isDropIndexSelected) {
            return;
        }
        const clonedCollection = [];
        for (let i = 0; i < this.selectedPageIndexes.length; i++) {
            clonedCollection.push(this.clonedCollection(this.tempOrganizePagesCollection.
                find((item) => {
                return item.currentPageIndex ===
                    this.selectedPageIndexes[parseInt(i.toString(), 10)];
            })));
        }
        const cloneSelectedIndexes = [];
        cloneSelectedIndexes.push(...this.selectedPageIndexes);
        this.addOrganizeAction(clonedCollection, 'Move Pages', [], cloneSelectedIndexes, this.dragEndIndex, this.isRightInsertion);
        this.rearrangePages(selectedPagesIndexes, dropIndex, isRightInsertion);
    }
    rearrangePages(selectedPagesIndexes, dropIndex, isRightInsertion) {
        // eslint-disable-next-line
        const proxy = this;
        this.tempOrganizePagesCollection =
            this.updateCollection(this.tempOrganizePagesCollection, selectedPagesIndexes, dropIndex, isRightInsertion);
        const pages = Array.from(this.tileAreaDiv.children);
        selectedPagesIndexes.sort((a, b) => a - b);
        const draggedElements = selectedPagesIndexes.map((index) => pages[parseInt(index.toString(), 10)]);
        let adjustedDropIndex = isRightInsertion ? dropIndex + 1 : dropIndex;
        draggedElements.forEach((element) => {
            pages.splice(adjustedDropIndex, 0, element);
            adjustedDropIndex += 1;
        });
        for (let i = 0; i < selectedPagesIndexes.length; i++) {
            if (selectedPagesIndexes[parseInt(i.toString(), 10)] >= dropIndex) {
                selectedPagesIndexes[parseInt(i.toString(), 10)] += draggedElements.length;
            }
        }
        selectedPagesIndexes.sort((a, b) => b - a).forEach((index) => {
            pages.splice(index, 1);
        });
        this.tileAreaDiv.innerHTML = '';
        pages.forEach((page, index) => {
            proxy.tileAreaDiv.appendChild(page);
            page.setAttribute('data-page-order', index.toString());
        });
        this.updatePageNumber();
    }
    updateCollection(collection, selectedIndexes, dropIndex, isRightInsertion) {
        const collectionCopy = [];
        let index = 0;
        const isAlreadyAdded = [];
        selectedIndexes.sort();
        dropIndex = isRightInsertion ? dropIndex + 1 : dropIndex;
        let selectedIndexesUnderDropIndexCount = 0;
        selectedIndexes.forEach((index) => {
            if (index < dropIndex) {
                selectedIndexesUnderDropIndexCount++;
            }
        });
        const sortedCollection = collection.sort((a, b) => this.sorting(a['currentPageIndex'], b['currentPageIndex']));
        const nullCurrentPageIndexCount = sortedCollection.filter((item) => item.currentPageIndex === null).length;
        sortedCollection.forEach(function (item) {
            if (item.currentPageIndex === null) {
                collectionCopy.push(Object.assign({}, item));
            }
        });
        //Updated currentPageIndex for the pages before drop index
        for (let i = 0; i < sortedCollection.length; i++) {
            // checking the given Currentpageindex exists in the selected indexes
            let isCurrentPageIndexInSelectedIndexes = false;
            for (let j = 0; j < selectedIndexes.length; j++) {
                if (sortedCollection[parseInt(i.toString(), 10)].currentPageIndex === selectedIndexes[parseInt(j.toString(), 10)]) {
                    isCurrentPageIndexInSelectedIndexes = true;
                    break;
                }
            }
            if (index === dropIndex - selectedIndexesUnderDropIndexCount) {
                break;
            }
            if (!isCurrentPageIndexInSelectedIndexes &&
                !this.containsPageDetails(sortedCollection[parseInt(i.toString(), 10)], isAlreadyAdded)) {
                if (!isNullOrUndefined(sortedCollection[parseInt(i.toString(), 10)].currentPageIndex)) {
                    collectionCopy.push(Object.assign({}, sortedCollection[parseInt(i.toString(), 10)]));
                    isAlreadyAdded.push(sortedCollection[parseInt(i.toString(), 10)]);
                    collectionCopy[collectionCopy.length - 1].currentPageIndex = index;
                    index = index + 1;
                }
            }
        }
        //Updated currentPageIndex for the selected pages in the drop index
        for (let i = 0; i < sortedCollection.length; i++) {
            let isCurrentPageIndexInSelectedIndexes = false;
            for (let j = 0; j < selectedIndexes.length; j++) {
                if (sortedCollection[parseInt(i.toString(), 10)].currentPageIndex === selectedIndexes[parseInt(j.toString(), 10)]) {
                    isCurrentPageIndexInSelectedIndexes = true;
                    break;
                }
            }
            if (isCurrentPageIndexInSelectedIndexes &&
                !this.containsPageDetails(sortedCollection[parseInt(i.toString(), 10)], isAlreadyAdded)) {
                collectionCopy.push(Object.assign({}, sortedCollection[parseInt(i.toString(), 10)]));
                isAlreadyAdded.push(sortedCollection[parseInt(i.toString(), 10)]);
                collectionCopy[collectionCopy.length - 1].currentPageIndex = index;
                index = index + 1;
            }
        }
        //Updated currentPageIndex for the pages after drop index
        for (let i = nullCurrentPageIndexCount; i < sortedCollection.length; i++) {
            // checking the given Currentpageindex exists in the selected indexes
            let isCurrentPageIndexInSelectedIndexes = false;
            for (let j = 0; j < selectedIndexes.length; j++) {
                if (sortedCollection[parseInt(i.toString(), 10)].currentPageIndex === selectedIndexes[parseInt(j.toString(), 10)]) {
                    isCurrentPageIndexInSelectedIndexes = true;
                    break;
                }
            }
            if (!isCurrentPageIndexInSelectedIndexes &&
                !this.containsPageDetails(sortedCollection[parseInt(i.toString(), 10)], isAlreadyAdded)) {
                collectionCopy.push(Object.assign({}, sortedCollection[parseInt(i.toString(), 10)]));
                isAlreadyAdded.push(sortedCollection[parseInt(i.toString(), 10)]);
                collectionCopy[collectionCopy.length - 1].currentPageIndex = index;
                index = index + 1;
            }
        }
        return collectionCopy;
    }
    /**
     * @private
     * @param {any} a - a value
     * @param {any} b - b value
     * @returns {number} - number
     */
    sorting(a, b) {
        a = !isNullOrUndefined(a) ? parseInt(a.toString(), 10) : -1;
        b = !isNullOrUndefined(b) ? parseInt(b.toString(), 10) : -1;
        if (a > b) {
            return 1;
        }
        if (a < b) {
            return -1;
        }
        return 0;
    }
    containsPageDetails(value, array) {
        let pageIndexFound = false;
        let currentPageIndexFound = false;
        for (let i = 0; i < array.length; i++) {
            if (array[parseInt(i.toString(), 10)].pageIndex === value.pageIndex) {
                pageIndexFound = true;
            }
            if (array[parseInt(i.toString(), 10)].currentPageIndex === value.currentPageIndex) {
                currentPageIndexFound = true;
            }
        }
        return pageIndexFound && currentPageIndexFound;
    }
    renderThumbnailImage() {
        this.organizePagesCollection = [];
        for (let i = 0; i < this.pdfViewer.pageCount; i++) {
            this.tileImageRender(i);
            this.organizePagesCollection.
                push(new OrganizeDetails(i, i, null, false, false, false, false, false, false, this.getRotatedAngle(this.pdfViewerBase.pageSize[parseInt(i.toString(), 10)].rotation.toString()), this.pdfViewerBase.pageSize[parseInt(i.toString(), 10)], false, null, null, null));
        }
        this.tempOrganizePagesCollection = JSON.parse(JSON.stringify(this.organizePagesCollection));
    }
    bindImportDocEvent() {
        if (this.pdfViewer.pageOrganizerSettings.canImport) {
            const importDocElement = document.getElementById(this.pdfViewer.element.id + '_import_pages');
            if (importDocElement) {
                this.importDocInputElement.click();
            }
        }
    }
    /**
     * @param {number} pageIndex - It describes about the page index
     * @param {number} subIndex - It describes about the sub index
     * @param {number} pageOrder - It describes about the page order
     * @param {HTMLElement} targetElement - It describes about the target element
     * @param {boolean} isNewPage - It describes about the isNewPage
     * @param {boolean} isBefore - It describes about the isBefore
     * @param {boolean} isEmptyPage - It describes about the isEmptyPage
     * @param {boolean} isImportedPage - It describes about the isImportedPage
     * @param {string} documentName - It describes about the documentName
     * @private
     * @returns {void}
     */
    tileImageRender(pageIndex, subIndex, pageOrder, targetElement, isNewPage, isBefore, isEmptyPage, isImportedPage, documentName) {
        const base64Image = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAAaADAAQAAAABAAAAAQAAAAD5Ip3+AAAAC0lEQVQIHWP4DwQACfsD/Qy7W+cAAAAASUVORK5CYII=';
        this.pageLink = createElement('div', { id: 'anchor_page_' + pageIndex, className: 'e-pv-organize-anchor-node' });
        const imageZoomFactor = this.getImageZoomFactor(this.pageLink.cloneNode(true));
        if (isNewPage) {
            this.pageLink.id = this.pageLink.id + '_' + subIndex;
            this.pageLink.setAttribute('data-page-order', pageOrder.toString());
        }
        else {
            this.pageLink.setAttribute('data-page-order', pageIndex.toString());
        }
        this.pageLink.style.width = 140 * imageZoomFactor + 'px';
        this.pageLink.style.height = 140 * imageZoomFactor + 'px';
        this.thumbnail = createElement('div', { id: this.pdfViewer.element.id + '_organize_page_' + pageIndex, className: 'e-pv-organize-tile e-pv-thumbnail-column' });
        if (isNewPage) {
            this.thumbnail.id = this.thumbnail.id + '_' + subIndex;
        }
        this.imageContainer = createElement('div', { id: this.pdfViewer.element.id + '_container_image_' + pageIndex, className: 'e-pv-image-container' });
        if (isNewPage) {
            this.imageContainer.id = this.imageContainer.id + '_' + subIndex;
        }
        let pageSize;
        if (!isNewPage && !isEmptyPage) {
            pageSize = this.pdfViewerBase.pageSize[parseInt(pageIndex.toString(), 10)];
        }
        else {
            pageSize = this.tempOrganizePagesCollection.find((item) => { return item.currentPageIndex === pageOrder; }).pageSize;
            if (isBefore && pageOrder - 1 >= 0) {
                pageSize = this.tempOrganizePagesCollection.find(function (item) { return item.currentPageIndex === pageOrder - 1; }).pageSize;
            }
        }
        this.thumbnailImage = createElement('img', { id: this.pdfViewer.element.id + '_organize_image_' + pageIndex, className: 'e-pv-organize-image' });
        if (isNewPage) {
            this.thumbnailImage.id = this.thumbnailImage.id + '_' + subIndex;
        }
        let width;
        let height;
        if (pageSize.height > pageSize.width) {
            width = 100 * pageSize.width / pageSize.height;
            height = 100;
        }
        else {
            width = 100;
            height = 100 * pageSize.height / pageSize.width;
        }
        this.thumbnailImage.style.width = width + '%';
        this.thumbnailImage.style.height = height + '%';
        if (isEmptyPage) {
            this.thumbnailImage.src = base64Image;
        }
        else if (pageOrder && pageOrder !== null) {
            const pageDetail = this.tempOrganizePagesCollection.find((item) => { return item.currentPageIndex === pageOrder; });
            if (pageDetail && pageDetail.pageIndex !== -1) {
                this.thumbnailImage.src = this.dataDetails[parseInt(pageDetail.pageIndex.toString(), 10)].image;
            }
            else if (pageDetail && pageDetail.copiedPageIndex !== null && pageDetail.copiedPageIndex >= 0) {
                this.thumbnailImage.src = this.dataDetails[parseInt(pageDetail.copiedPageIndex.toString(), 10)].image;
            }
            else {
                this.thumbnailImage.src = base64Image;
            }
        }
        else {
            this.thumbnailImage.src = this.dataDetails[parseInt(pageIndex.toString(), 10)].image;
        }
        this.imageContainer.addEventListener('click', (e) => {
            this.handleImageContainerClick(e);
        });
        this.thumbnailImage.alt = this.pdfViewer.element.id + '_organize_page_' + pageIndex;
        if (isNewPage) {
            this.thumbnailImage.alt = this.pdfViewer.element.id + '_organize_page_' + pageOrder;
        }
        if (isImportedPage) {
            const importDownloadIcon = createElement('span', { id: this.pdfViewer.element.id + '_organize_import_download_icon_' + pageIndex, className: 'e-pv-organize-import-download-icon e-pv-import-icon e-pv-icon' });
            this.importImageWrapper = createElement('div', { id: this.pdfViewer.element.id + '_organize_import_image_wrapper_' + pageIndex, className: 'e-pv-organize-import-image-wrapper' });
            this.importImageWrapper.appendChild(importDownloadIcon);
            this.imageContainer.appendChild(this.importImageWrapper);
        }
        else {
            this.imageContainer.appendChild(this.thumbnailImage);
        }
        let rotateAngle = 0;
        if (isNewPage && !isNullOrUndefined(this.tempOrganizePagesCollection.find((item) => { return item.currentPageIndex === pageOrder; }))) {
            rotateAngle = this.tempOrganizePagesCollection.find((item) => { return item.currentPageIndex === pageOrder; }).rotateAngle;
            this.imageContainer.style.transform = 'rotate(' + rotateAngle + 'deg)';
        }
        this.thumbnail.appendChild(this.imageContainer);
        const thumbnailPageNumber = createElement('div', { id: this.pdfViewer.element.id + '_tile_pagenumber_' + pageIndex, className: 'e-pv-tile-number' });
        if (isNewPage) {
            thumbnailPageNumber.id = thumbnailPageNumber.id + '_' + subIndex;
        }
        if (isImportedPage) {
            thumbnailPageNumber.textContent = documentName;
        }
        else if (isNewPage) {
            thumbnailPageNumber.textContent = (pageOrder + 1).toString();
        }
        else {
            thumbnailPageNumber.textContent = (pageIndex + 1).toString();
        }
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.className = 'e-pv-organize-tile-checkbox';
        input.id = 'checkboxdiv_page_' + pageIndex;
        if (isNewPage) {
            input.id = input.id + '_' + subIndex;
        }
        this.thumbnail.appendChild(input);
        const checkBoxObj = new CheckBox({ disabled: false, checked: false, change: this.onSelectClick.bind(this) });
        checkBoxObj.appendTo(input);
        input.parentElement.style.height = '100%';
        input.parentElement.style.width = '100%';
        input.parentElement.style.display = 'none';
        const buttondiv = createElement('div', { id: this.pdfViewer.element.id + '_organize_buttondiv_' + pageIndex, className: 'e-pv-organize-buttondiv' });
        if (isNewPage) {
            buttondiv.id = buttondiv.id + '_' + subIndex;
        }
        this.deleteButton = createElement('button', { id: this.pdfViewer.element.id + '_delete_page_' + pageIndex, attrs: { 'aria-label': this.pdfViewer.localeObj.getConstant('Delete Page'), 'tabindex': '-1' } });
        if (isNewPage) {
            this.deleteButton.id = this.deleteButton.id + '_' + subIndex;
        }
        this.deleteButton.className = 'e-pv-tbar-btn e-pv-delete-button e-btn e-pv-organize-pdf-tile-btn';
        this.deleteButton.setAttribute('type', 'button');
        const deleteButtonSpan = createElement('span', { id: this.pdfViewer.element.id + '_delete' + '_icon', className: 'e-pv-delete-icon e-pv-icon' });
        this.deleteButton.appendChild(deleteButtonSpan);
        const deleteButtonTooltip = new Tooltip({
            content: initializeCSPTemplate(function () { return this.pdfViewer.localeObj.getConstant('Delete Page'); }, this), opensOn: 'Hover', beforeOpen: this.onTooltipBeforeOpen.bind(this)
        });
        deleteButtonTooltip.appendTo(this.deleteButton);
        this.rotateRightButton = createElement('button', { id: this.pdfViewer.element.id + '_rotate_page_' + pageIndex, attrs: { 'aria-label': this.pdfViewer.localeObj.getConstant('Rotate Right'), 'tabindex': '-1' } });
        if (isNewPage) {
            this.rotateRightButton.id = this.rotateRightButton.id + '_' + subIndex;
        }
        this.rotateRightButton.className = 'e-pv-tbar-btn e-pv-rotate-right-button e-btn e-pv-organize-pdf-tile-btn';
        this.rotateRightButton.setAttribute('type', 'button');
        const rotateButtonSpan = createElement('span', { id: this.pdfViewer.element.id + '_rotate-right' + '_icon', className: 'e-pv-rotate-right-icon e-pv-icon' });
        this.rotateRightButton.appendChild(rotateButtonSpan);
        const rotateButtonTooltip = new Tooltip({
            content: initializeCSPTemplate(function () { return this.pdfViewer.localeObj.getConstant('Rotate Right'); }, this), opensOn: 'Hover', beforeOpen: this.onTooltipBeforeOpen.bind(this)
        });
        rotateButtonTooltip.appendTo(this.rotateRightButton);
        this.rotateLeftButton = createElement('button', { id: this.pdfViewer.element.id + '_rotate_page_' + pageIndex, attrs: { 'aria-label': this.pdfViewer.localeObj.getConstant('Rotate Left'), 'tabindex': '-1' } });
        if (isNewPage) {
            this.rotateLeftButton.id = this.rotateLeftButton.id + '_' + subIndex;
        }
        this.rotateLeftButton.className = 'e-pv-tbar-btn e-pv-rotate-left-button e-btn e-pv-organize-pdf-tile-btn';
        this.rotateLeftButton.setAttribute('type', 'button');
        const rotateLeftButtonSpan = createElement('span', { id: this.pdfViewer.element.id + '_rotate_left' + '_icon', className: 'e-pv-rotate-left-icon e-pv-icon' });
        this.rotateLeftButton.appendChild(rotateLeftButtonSpan);
        const rotateLeftButtonTooltip = new Tooltip({
            content: initializeCSPTemplate(function () { return this.pdfViewer.localeObj.getConstant('Rotate Left'); }, this), opensOn: 'Hover', beforeOpen: this.onTooltipBeforeOpen.bind(this)
        });
        rotateLeftButtonTooltip.appendTo(this.rotateLeftButton);
        this.copyButton = createElement('button', { id: this.pdfViewer.element.id + '_copy_page_' + pageIndex, attrs: { 'aria-label': this.pdfViewer.localeObj.getConstant('Copy Page'), 'tabindex': '-1' } });
        if (isNewPage) {
            this.copyButton.id = this.copyButton.id + '_' + subIndex;
        }
        this.copyButton.className = 'e-pv-tbar-btn e-pv-copy-button e-btn e-pv-organize-pdf-tile-btn';
        this.copyButton.setAttribute('type', 'button');
        const copyButtonSpan = createElement('span', { id: this.pdfViewer.element.id + '_copy' + '_icon', className: 'e-pv-copy-icon e-pv-icon' });
        this.copyButton.appendChild(copyButtonSpan);
        const copyButtonTooltip = new Tooltip({
            content: initializeCSPTemplate(function () { return this.pdfViewer.localeObj.getConstant('Copy Page'); }, this), opensOn: 'Hover', beforeOpen: this.onTooltipBeforeOpen.bind(this)
        });
        copyButtonTooltip.appendTo(this.copyButton);
        this.insertRightButton = createElement('button', { id: this.pdfViewer.element.id + '_insert_page_' + pageIndex, attrs: { 'aria-label': this.pdfViewer.localeObj.getConstant('Insert Right'), 'tabindex': '-1' } });
        if (isNewPage) {
            this.insertRightButton.id = this.insertRightButton.id + '_' + subIndex;
        }
        this.insertRightButton.className = 'e-pv-tbar-btn e-pv-insert-right-button e-btn e-pv-organize-pdf-tile-btn';
        this.insertRightButton.setAttribute('type', 'button');
        const insertRightButtonSpan = createElement('span', { id: this.pdfViewer.element.id + '_insert_right' + '_icon', className: 'e-icons e-plus' });
        this.insertRightButton.appendChild(insertRightButtonSpan);
        const insertRightButtonTooltip = new Tooltip({
            content: initializeCSPTemplate(function () { return this.pdfViewer.localeObj.getConstant('Insert Right'); }, this), opensOn: 'Hover', beforeOpen: this.onTooltipBeforeOpen.bind(this)
        });
        insertRightButtonTooltip.appendTo(this.insertRightButton);
        this.insertLeftButton = createElement('button', { id: this.pdfViewer.element.id + '_insert_page_' + pageIndex, attrs: { 'aria-label': this.pdfViewer.localeObj.getConstant('Insert Left'), 'tabindex': '-1' } });
        if (isNewPage) {
            this.insertLeftButton.id = this.insertLeftButton.id + '_' + subIndex;
        }
        this.insertLeftButton.className = 'e-pv-tbar-btn e-pv-insert-left-button e-btn e-pv-organize-pdf-tile-btn';
        this.insertLeftButton.setAttribute('type', 'button');
        const insertLeftButtonSpan = createElement('span', { id: this.pdfViewer.element.id + '_insert_left' + '_icon', className: 'e-icons e-plus' });
        this.insertLeftButton.appendChild(insertLeftButtonSpan);
        const insertLeftButtonTooltip = new Tooltip({
            content: initializeCSPTemplate(function () { return this.pdfViewer.localeObj.getConstant('Insert Left'); }, this), opensOn: 'Hover', beforeOpen: this.onTooltipBeforeOpen.bind(this)
        });
        insertLeftButtonTooltip.appendTo(this.insertLeftButton);
        if (!this.pdfViewer.pageOrganizerSettings.canInsert) {
            this.insertLeftButton.setAttribute('disabled', 'disabled');
            this.insertLeftButton.firstElementChild.classList.add('e-disabled');
            this.insertRightButton.setAttribute('disabled', 'disabled');
            this.insertRightButton.firstElementChild.classList.add('e-disabled');
        }
        if (!this.pdfViewer.pageOrganizerSettings.canRotate) {
            this.rotateLeftButton.setAttribute('disabled', 'disabled');
            this.rotateLeftButton.firstElementChild.classList.add('e-disabled');
            this.rotateRightButton.setAttribute('disabled', 'disabled');
            this.rotateRightButton.firstElementChild.classList.add('e-disabled');
        }
        if (!this.pdfViewer.pageOrganizerSettings.canDelete) {
            this.deleteButton.setAttribute('disabled', 'disabled');
            this.deleteButton.firstElementChild.classList.add('e-disabled');
        }
        if (!this.pdfViewer.pageOrganizerSettings.canCopy) {
            this.copyButton.setAttribute('disabled', 'disabled');
            this.copyButton.firstElementChild.classList.add('e-disabled');
        }
        buttondiv.appendChild(this.insertLeftButton);
        if (!isImportedPage) {
            buttondiv.appendChild(this.rotateLeftButton);
            buttondiv.appendChild(this.rotateRightButton);
            buttondiv.appendChild(this.copyButton);
        }
        buttondiv.appendChild(this.deleteButton);
        buttondiv.appendChild(this.insertRightButton);
        this.thumbnail.appendChild(buttondiv);
        buttondiv.style.display = 'none';
        this.pageLink.appendChild(this.thumbnail);
        this.tileAreaDiv.appendChild(this.pageLink);
        this.pageLink.appendChild(thumbnailPageNumber);
        this.rotateRightButton.addEventListener('click', this.rotateButtonClick);
        this.rotateLeftButton.addEventListener('click', this.rotateLeftButtonClick);
        this.insertRightButton.addEventListener('click', this.insertRightButtonClick);
        this.insertLeftButton.addEventListener('click', this.insertLeftButtonClick);
        this.deleteButton.addEventListener('click', this.deleteButtonClick);
        this.copyButton.addEventListener('click', this.copyButtonClick);
        this.pageLink.addEventListener('mouseover', this.thumbnailMouseOver);
        this.pageLink.addEventListener('mouseleave', this.thumbnailMouseLeave);
        this.movePages();
        if (isNewPage) {
            if (isBefore) {
                this.tileAreaDiv.insertBefore(this.pageLink, targetElement);
            }
            else {
                this.tileAreaDiv.insertBefore(this.pageLink, targetElement.nextSibling);
            }
        }
    }
    handleImageContainerClick(event) {
        const anchorNode = event.target.closest('.e-pv-organize-anchor-node');
        const nearestCheckBox = anchorNode.querySelector('.e-pv-organize-tile-checkbox.e-control.e-checkbox.e-lib');
        if (event instanceof PointerEvent) {
            if (event.pointerType === 'touch') {
                this.isTouchEvent = true;
            }
            else if (event.pointerType === 'mouse') {
                this.isTouchEvent = false;
            }
        }
        else if (!(this.pdfViewerBase.isMacSafari) && event instanceof TouchEvent) {
            this.isTouchEvent = true;
        }
        else if (event instanceof MouseEvent) {
            this.isTouchEvent = false;
        }
        if (nearestCheckBox && !isNullOrUndefined(nearestCheckBox) &&
            !isNullOrUndefined(nearestCheckBox.ej2_instances) && nearestCheckBox.ej2_instances.length > 0) {
            nearestCheckBox.ej2_instances[0].click();
        }
    }
    movePages() {
        // eslint-disable-next-line
        const proxy = this;
        const draggableElement = this.imageContainer;
        this.dragObj = new Draggable(draggableElement, {
            dragArea: this.tileAreaDiv,
            isDragScroll: true,
            enableTapHold: true,
            tapHoldThreshold: Browser.isDevice ? 50 : 750,
            helper: (e) => {
                if (this.pdfViewer.pageOrganizerSettings.canRearrange) {
                    // Return a clone or another element as the drag avatar
                    const cloneTargetEle = e.element.querySelector('.e-pv-organize-image, .e-pv-organize-import-image-wrapper');
                    const clone = cloneTargetEle.cloneNode(true);
                    clone.style.width = cloneTargetEle.clientWidth + 'px';
                    clone.style.height = cloneTargetEle.clientHeight + 'px';
                    this.virtualEle = createElement('div', { className: 'e-pv-virtual-image-container' });
                    this.virtualEle.appendChild(clone);
                    this.tileAreaWrapper.appendChild(this.virtualEle);
                    return this.virtualEle;
                }
                return null;
            },
            drag: (e) => {
                e.event.preventDefault();
                if (proxy.pdfViewer.pageOrganizerSettings.canRearrange) {
                    proxy.autoScroll(e);
                    proxy.addSelectionRingStyle();
                    const mainTileElement = !isNullOrUndefined(e.target) && e.target instanceof Element ? e.target.closest('.e-pv-organize-anchor-node') : null;
                    if (!isNullOrUndefined(mainTileElement)) {
                        const pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
                        proxy.dragHoveredIndex = pageOrder;
                        const tileRect = mainTileElement.getBoundingClientRect();
                        let outerBorder = document.querySelector('.e-pv-organize-outer-border');
                        // If the outerBorder does not exist's, creating it
                        if (isNullOrUndefined(outerBorder)) {
                            outerBorder = createElement('div', { className: 'e-pv-organize-outer-border' });
                            proxy.tileAreaWrapper.appendChild(outerBorder);
                        }
                        outerBorder.style.display = 'block';
                        const isHoveredOnSelected = proxy.isHoveredOnSelectedPages(proxy.selectedPageIndexes, proxy.dragHoveredIndex);
                        if (isHoveredOnSelected && !isNullOrUndefined(e.target) && (e.target.classList.contains('e-pv-organize-image') || e.target.classList.contains('e-pv-organize-import-image-wrapper') || e.target.classList.contains('e-pv-image-container'))) {
                            outerBorder.classList.add('e-pv-selected');
                            outerBorder.classList.remove('e-pv-not-selected');
                        }
                        else if (!isNullOrUndefined(e.target) && (e.target.classList.contains('e-pv-organize-image') || e.target.classList.contains('e-pv-organize-import-image-wrapper') || e.target.classList.contains('e-pv-image-container'))) {
                            outerBorder.classList.add('e-pv-not-selected');
                            outerBorder.classList.remove('e-pv-selected');
                        }
                        proxy.handlePageMove(e, tileRect, proxy.gapBetweenDivs, outerBorder);
                    }
                }
            },
            dragStart: (e) => {
                proxy.selectedPageIndexes = [];
                if (proxy.pdfViewer.pageOrganizerSettings.canRearrange) {
                    if (e.element.parentElement.querySelector('.e-pv-organize-tile-checkbox').checked) {
                        const checkedElements = proxy.tileAreaDiv.querySelectorAll('.e-pv-organize-node-selection-ring');
                        for (let i = 0; i < checkedElements.length; i++) {
                            proxy.selectedPageIndexes.push(parseInt(checkedElements[parseInt(i.toString(), 10)].getAttribute('data-page-order'), 10));
                            checkedElements[parseInt(i.toString(), 10)].classList.add('e-pv-organize-tile-draggedEle');
                            const imageElement = checkedElements[parseInt(i.toString(), 10)].querySelector('.e-pv-organize-image, .e-pv-organize-import-image-wrapper');
                            if (imageElement) {
                                imageElement.classList.add('e-pv-organize-tile-draggedEle');
                            }
                        }
                    }
                    else {
                        const anchorElement = e.element.closest('.e-pv-organize-anchor-node');
                        if (anchorElement) {
                            proxy.selectedPageIndexes.push(parseInt(anchorElement.getAttribute('data-page-order'), 10));
                            anchorElement.classList.add('e-pv-organize-tile-draggedEle');
                            const imageElement = anchorElement.querySelector('.e-pv-organize-image, .e-pv-organize-import-image-wrapper');
                            if (imageElement) {
                                imageElement.classList.add('e-pv-organize-tile-draggedEle');
                            }
                        }
                    }
                    const notification = createElement('span', {
                        className: 'e-badge e-badge-primary e-badge-overlap e-badge-notification',
                        innerHTML: '' + this.selectedPageIndexes.length
                    });
                    notification.classList.add('e-pv-notification');
                    proxy.virtualEle.append(notification);
                    proxy.addSelectionRingStyle();
                }
            },
            dragStop: (e) => {
                const clearDraggedElements = () => {
                    proxy.virtualEle.parentNode.removeChild(proxy.virtualEle);
                    const draggedElements = proxy.tileAreaDiv.querySelectorAll('.e-pv-organize-tile-draggedEle');
                    draggedElements.forEach((element) => {
                        element.classList.remove('e-pv-organize-tile-draggedEle');
                    });
                    const outerBorder = document.querySelector('.e-pv-organize-outer-border');
                    if (!isNullOrUndefined(outerBorder)) {
                        outerBorder.classList.remove('e-pv-selected', 'e-pv-not-selected');
                        proxy.selectedPageIndexes = [];
                    }
                };
                if (proxy.autoScrollInterval !== null) {
                    clearInterval(proxy.autoScrollInterval);
                    proxy.autoScrollInterval = null;
                }
                proxy.removeSelectionRingStyle();
                if (e.target instanceof Element && e.target.classList) {
                    if (e.target == null || !(e.target.classList.contains('e-pv-organize-image') || e.target.classList.contains('e-pv-organize-import-image-wrapper') || e.target.classList.contains('e-pv-image-container'))) {
                        clearDraggedElements();
                    }
                }
                else {
                    clearDraggedElements();
                }
            }
        });
        const droppableElement = this.thumbnail;
        this.dropObj = new Droppable(droppableElement, {
            drop: (e) => {
                if (proxy.autoScrollInterval !== null) {
                    clearInterval(proxy.autoScrollInterval);
                    proxy.autoScrollInterval = null;
                }
                proxy.removeSelectionRingStyle();
                const outerBorder = document.querySelector('.e-pv-organize-outer-border');
                // Remove the element from the DOM
                if (outerBorder) {
                    outerBorder.classList.remove('e-pv-selected', 'e-pv-not-selected');
                    outerBorder.parentNode.removeChild(outerBorder);
                }
                if (proxy.virtualEle && proxy.virtualEle.parentNode) {
                    proxy.virtualEle.parentNode.removeChild(proxy.virtualEle);
                    proxy.virtualEle = null;
                }
                proxy.pageDragDrop(e);
                const draggedElements = proxy.tileAreaDiv.querySelectorAll('.e-pv-organize-tile-draggedEle');
                draggedElements.forEach((element) => {
                    element.classList.remove('e-pv-organize-tile-draggedEle');
                });
                proxy.selectedPageIndexes = [];
            },
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            over: function (e) {
            },
            out: function (e) {
                const outerBorder = document.querySelector('.e-pv-organize-outer-border');
                if (!isNullOrUndefined(outerBorder)) {
                    outerBorder.classList.remove('e-pv-selected', 'e-pv-not-selected');
                }
            }
        });
    }
    autoScroll(e) {
        // eslint-disable-next-line
        const proxy = this;
        const viewportY = e.event.type === 'touchmove' ? e.event.touches[0].clientY : e.event.clientY;
        const edgeSize = 10;
        this.autoScrollInterval = null;
        const viewportHeight = window.innerHeight;
        let edgeTop = edgeSize;
        let edgeBottom = (viewportHeight - edgeSize);
        const toolbarBottom = document.getElementById(this.pdfViewer.element.id + '_toolbar_appearance').getBoundingClientRect().bottom + edgeSize;
        const footer = this.organizeDialog.element.getElementsByClassName('e-footer-content');
        let footerBounds;
        if (!isNullOrUndefined(footer) && footer.length > 0) {
            footerBounds = footer[0].getBoundingClientRect();
        }
        const footerTop = !isNullOrUndefined(footerBounds) ? (footerBounds.top - edgeSize) :
            (this.tileAreaDiv.getBoundingClientRect().bottom - edgeSize);
        edgeTop = parseFloat(Math.max(edgeTop, toolbarBottom).toFixed(2));
        edgeBottom = Math.min(edgeBottom, footerTop);
        if (this.virtualEle.getBoundingClientRect().height >= this.tileAreaDiv.getBoundingClientRect().height) {
            clearTimeout(this.autoScrollInterval);
            proxy.autoScrollInterval = null;
            return;
        }
        const isInTopEdge = (parseFloat(this.virtualEle.getBoundingClientRect().top.toFixed(2)) <= edgeTop);
        const isInBottomEdge = (this.virtualEle.getBoundingClientRect().bottom >= edgeBottom);
        // If the mouse is not in the viewport edge, there's no need to calculate anything else.
        if (!(isInTopEdge || isInBottomEdge)) {
            clearTimeout(this.autoScrollInterval);
            proxy.autoScrollInterval = null;
            return;
        }
        const maxScrollY = (this.tileAreaDiv.scrollHeight - this.tileAreaDiv.clientHeight);
        (function checkForWindowScroll() {
            clearTimeout(proxy.autoScrollInterval);
            proxy.autoScrollInterval = null;
            if (adjustWindowScroll()) {
                proxy.autoScrollInterval = window.setTimeout(checkForWindowScroll, 30);
            }
            // eslint-disable-next-line
        })();
        function adjustWindowScroll() {
            proxy.tileAreaDiv.onscroll = function () {
                const outerBorder = document.querySelector('.e-pv-organize-outer-border');
                if (!isNullOrUndefined(outerBorder)) {
                    outerBorder.style.display = 'none';
                }
            };
            const elementBounds = proxy.virtualEle.getBoundingClientRect();
            const dragDownDiffrence = elementBounds.bottom - (proxy.previousClientY + elementBounds.height);
            const dragUpDiffrence = elementBounds.top - proxy.previousClientY;
            proxy.previousClientY = elementBounds.top;
            const currentScrollY = proxy.tileAreaDiv.scrollTop;
            const canScrollUp = (currentScrollY > 0 && dragUpDiffrence <= 0);
            const canScrollDown = (currentScrollY < maxScrollY && dragDownDiffrence >= 0);
            let nextScrollY = currentScrollY;
            const maxStep = 10;
            // Should we scroll up?
            if (isInTopEdge && canScrollUp) {
                const intensity = ((edgeTop - proxy.virtualEle.getBoundingClientRect().top) / edgeSize);
                nextScrollY = (nextScrollY - (maxStep * intensity));
                // Should we scroll down?
            }
            else if (isInBottomEdge && canScrollDown) {
                const intensity = ((proxy.virtualEle.getBoundingClientRect().bottom - edgeBottom) / edgeSize);
                nextScrollY = (nextScrollY + (maxStep * intensity));
            }
            nextScrollY = Math.max(0, Math.min(maxScrollY, nextScrollY));
            if (nextScrollY !== currentScrollY) {
                proxy.tileAreaDiv.scrollTop = nextScrollY;
                return (true);
            }
            else {
                return (false);
            }
        }
    }
    handlePageMove(e, tileRect, gapBetweenDivs, outerBorder) {
        const isRightInsertion = this.isTileRightInsertion(e);
        if (!isNullOrUndefined(this.isTileRightInsertion)) {
            const offset = isRightInsertion ? (tileRect['width'] + gapBetweenDivs / 2) : (-gapBetweenDivs / 2);
            const parentBound = outerBorder.parentElement.getBoundingClientRect();
            outerBorder.style.left = (tileRect['x'] + offset - parentBound.x) + 'px';
            outerBorder.style.top = (tileRect['top'] - parentBound.y) + 'px';
            outerBorder.style.height = tileRect['height'] + 'px';
            this.isRightInsertion = isRightInsertion;
        }
    }
    isTileRightInsertion(e) {
        const mainTileElement = !isNullOrUndefined(e.target) ? e.target.closest('.e-pv-organize-anchor-node') : null;
        if (!isNullOrUndefined(mainTileElement)) {
            const tileRect = mainTileElement.getBoundingClientRect();
            const virtualElementClientX = e.event.type === 'mousemove' ? e.event.clientX : e.event.touches[0].clientX;
            return virtualElementClientX > tileRect['x'] + (tileRect['width'] / 2);
        }
        return null;
    }
    addSelectionRingStyle() {
        const anchorElements = this.tileAreaDiv.querySelectorAll('.e-pv-organize-anchor-node');
        for (let i = 0; i < this.selectedPageIndexes.length; i++) {
            anchorElements[this.selectedPageIndexes[parseInt(i.toString(), 10)]].classList.add('e-pv-dragging-style');
        }
    }
    removeSelectionRingStyle() {
        const anchorElements = this.tileAreaDiv.querySelectorAll('.e-pv-organize-anchor-node');
        for (let i = 0; i < this.selectedPageIndexes.length; i++) {
            anchorElements[this.selectedPageIndexes[parseInt(i.toString(), 10)]].classList.remove('e-pv-dragging-style');
        }
    }
    isHoveredOnSelectedPages(selectedPageIndexes, hoveredIndex) {
        let isHoveredOnSelectedPageIndex = false;
        for (let i = 0; i < selectedPageIndexes.length; i++) {
            if (selectedPageIndexes[parseInt(i.toString(), 10)] === hoveredIndex) {
                isHoveredOnSelectedPageIndex = true;
                break;
            }
        }
        return isHoveredOnSelectedPageIndex;
    }
    /**
     * @param {OrganizeDetails[]} UndoRedoTileActions - Specifies the details of the action occured page
     * @param {string} actionString - Specifies the Name of the action
     * @param {OrganizeDetails[]} toolbarActions - Collection to store multiple action as single action
     * @param {number[]} selectedPageIndexes - Collection to store selected page index
     * @param {number} dropIndex - Specifies where the page should be dropped
     * @param {boolean} isRightInsertion - Used to check whether the page should be dropped at right
     * @returns {void}
     * @private
     */
    addOrganizeAction(UndoRedoTileActions, actionString, toolbarActions, selectedPageIndexes, dropIndex, isRightInsertion) {
        const action = {
            UndoRedoTileActions: UndoRedoTileActions, action: actionString, toolbarActions: toolbarActions,
            selectedPagesIndexes: selectedPageIndexes, dropIndex: dropIndex,
            isRightInsertion: isRightInsertion
        };
        this.undoOrganizeCollection.push(action);
        this.redoOrganizeCollection = [];
        this.updateUndoRedoButtons();
    }
    updateUndoRedoButtons() {
        this.toolbar.items.forEach((item) => {
            if (item.id === this.pdfViewer.element.id + '_undo_organize_Pages') {
                this.enableToolbarItem(item.id, (this.undoOrganizeCollection.length > 0));
            }
            else if (item.id === this.pdfViewer.element.id + '_redo_organize_Pages') {
                this.enableToolbarItem(item.id, (this.redoOrganizeCollection.length > 0));
            }
        });
    }
    handlePageZoomButtonsVisibility(currentZoomValue) {
        if (currentZoomValue === this.getImageZoomMin()) {
            this.enablePageZoomButtons(false, false);
            this.enablePageZoomButtons(true, true);
        }
        else if (currentZoomValue === this.getImageZoomMax()) {
            this.enablePageZoomButtons(false, true);
            this.enablePageZoomButtons(true, false);
        }
        else {
            this.enablePageZoomButtons(true, true);
            this.enablePageZoomButtons(true, false);
        }
    }
    enablePageZoomButtons(isEnable, isIncrease) {
        let buttonToModify;
        if (isIncrease) {
            buttonToModify = this.pageZoomIncreaseButton;
        }
        else {
            buttonToModify = this.pageZoomDecreaseButton;
        }
        if (!isNullOrUndefined(buttonToModify)) {
            if (isEnable) {
                buttonToModify.removeAttribute('disabled');
                buttonToModify.firstElementChild.classList.remove('e-disabled');
            }
            else {
                buttonToModify.setAttribute('disabled', 'disabled');
                buttonToModify.firstElementChild.classList.add('e-disabled');
            }
        }
    }
    enableDisableToolbarItems() {
        const isCopyDisabled = false;
        const isCopyRotateDisabled = false;
        this.toolbar.items.forEach((item) => {
            if (item.id === this.pdfViewer.element.id + '_rotate_page_left') {
                this.enableToolbarItem(item.id, ((this.selectAllCheckBox.checked || this.selectAllCheckBox.indeterminate) &&
                    this.pdfViewer.pageOrganizerSettings.canRotate) && !this.getImportedItems(isCopyRotateDisabled));
            }
            else if (item.id === this.pdfViewer.element.id + '_rotate_page_right') {
                this.enableToolbarItem(item.id, ((this.selectAllCheckBox.checked || this.selectAllCheckBox.indeterminate) &&
                    this.pdfViewer.pageOrganizerSettings.canRotate) && !this.getImportedItems(isCopyRotateDisabled));
            }
            else if (item.id === this.pdfViewer.element.id + '_copy_page') {
                this.enableToolbarItem(item.id, ((this.selectAllCheckBox.checked || this.selectAllCheckBox.indeterminate)
                    && this.pdfViewer.pageOrganizerSettings.canCopy && !this.getCopiedItems(isCopyDisabled) &&
                    !this.getImportedItems(isCopyRotateDisabled)));
            }
            else if (item.id === this.pdfViewer.element.id + '_delete_selected') {
                this.enableToolbarItem(item.id, this.selectAllCheckBox.indeterminate && this.pdfViewer.pageOrganizerSettings.canDelete);
            }
            else if (item.id === this.pdfViewer.element.id + '_import_pages') {
                this.enableToolbarItem(item.id, this.pdfViewer.pageOrganizerSettings.canImport);
            }
        });
    }
    enableToolbarItem(elementID, isEnable) {
        const element = document.getElementById(elementID);
        if (!isNullOrUndefined(element) && !isNullOrUndefined(element.parentElement)) {
            this.toolbar.enableItems(element.parentElement, isEnable);
            element.setAttribute('tabindex', isEnable ? '0' : '-1');
            element.setAttribute('data-tabindex', isEnable ? '0' : '-1');
        }
    }
    disableTileDeleteButton() {
        if (this.tileAreaDiv.childElementCount === 1) {
            const mainTileElement = this.tileAreaDiv.querySelector('.e-pv-organize-anchor-node');
            const deleteButton = mainTileElement.querySelector('.e-pv-delete-button');
            if (!isNullOrUndefined(deleteButton)) {
                deleteButton.setAttribute('disabled', 'disabled');
                deleteButton.firstElementChild.classList.add('e-disabled');
            }
        }
        else {
            for (let i = 0; i < this.tileAreaDiv.childElementCount; i++) {
                let mainTileElement;
                if (this.tileAreaDiv.childNodes[parseInt(i.toString(), 10)].classList.contains('e-pv-organize-anchor-node')) {
                    mainTileElement = this.tileAreaDiv.childNodes[parseInt(i.toString(), 10)];
                }
                else {
                    mainTileElement = this.tileAreaDiv.childNodes[parseInt(i.toString(), 10)].querySelector('.e-pv-organize-anchor-node');
                }
                const deleteButton = mainTileElement.querySelector('.e-pv-delete-button');
                if (!isNullOrUndefined(deleteButton) && this.pdfViewer.pageOrganizerSettings.canDelete) {
                    deleteButton.removeAttribute('disabled');
                    deleteButton.firstElementChild.classList.remove('e-disabled');
                }
            }
        }
    }
    disableTileCopyRotateButton() {
        for (let i = 0; i < this.tempOrganizePagesCollection.length; i++) {
            const pageInfo = this.tempOrganizePagesCollection[parseInt(i.toString(), 10)];
            if (pageInfo.isImportedDoc && !pageInfo.isDeleted && !pageInfo.currentPageIndex != null) {
                const mainTileElement = this.tileAreaDiv.querySelector(`[data-page-order="${pageInfo.currentPageIndex.toString()}"]`);
                const rotateLeftButton = mainTileElement.querySelector('.e-pv-rotate-left-button');
                const rotateRightButton = mainTileElement.querySelector('.e-pv-rotate-right-button');
                const copyButton = mainTileElement.querySelector('.e-pv-copy-button');
                if (!isNullOrUndefined(rotateLeftButton)) {
                    rotateLeftButton.setAttribute('disabled', 'disabled');
                    rotateLeftButton.firstElementChild.classList.add('e-disabled');
                }
                if (!isNullOrUndefined(rotateRightButton)) {
                    rotateRightButton.setAttribute('disabled', 'disabled');
                    rotateRightButton.firstElementChild.classList.add('e-disabled');
                }
                if (!isNullOrUndefined(copyButton)) {
                    copyButton.setAttribute('disabled', 'disabled');
                    copyButton.firstElementChild.classList.add('e-disabled');
                }
            }
        }
    }
    disableTileCopyButton() {
        for (let i = 0; i < this.tempOrganizePagesCollection.length; i++) {
            const pageInfo = this.tempOrganizePagesCollection[parseInt(i.toString(), 10)];
            if (pageInfo.isInserted && !pageInfo.isDeleted && !pageInfo.currentPageIndex != null) {
                const mainTileElement = this.tileAreaDiv.querySelector(`[data-page-order="${pageInfo.currentPageIndex.toString()}"]`);
                const copyButton = mainTileElement.querySelector('.e-pv-copy-button');
                if (!isNullOrUndefined(copyButton)) {
                    copyButton.setAttribute('disabled', 'disabled');
                    copyButton.firstElementChild.classList.add('e-disabled');
                }
            }
        }
    }
    updateSelectAllCheckbox() {
        const totalCheckboxCount = this.tileAreaDiv.childElementCount;
        this.totalCheckedCount = this.tileAreaDiv.querySelectorAll('.e-pv-organize-node-selection-ring').length;
        if (this.selectAllCheckBox) {
            if (this.totalCheckedCount === 0) {
                this.selectAllCheckBox.indeterminate = false;
                this.selectAllCheckBox.checked = false;
            }
            else if (totalCheckboxCount === this.totalCheckedCount) {
                this.selectAllCheckBox.indeterminate = false;
                this.selectAllCheckBox.checked = true;
            }
            else {
                this.selectAllCheckBox.indeterminate = true;
            }
        }
    }
    setSelectionRingStyle(checkbox, anchornode) {
        if (!checkbox.checked) {
            anchornode.classList.remove('e-pv-organize-node-selection-ring');
        }
        else {
            anchornode.classList.add('e-pv-organize-node-selection-ring');
        }
        const childrenArray = Array.from(anchornode.children);
        for (const child of childrenArray) {
            const childArray = Array.from(child.children);
            for (const subchild of childArray) {
                if (subchild.classList.contains('e-checkbox-wrapper')) {
                    const id = (subchild.getElementsByClassName('e-control e-checkbox e-lib')[0]).id;
                    const cbObj = getComponent(document.getElementById(id), 'checkbox');
                    if (checkbox.checked) {
                        subchild.style.display = 'block';
                        subchild.children[0].style.display = 'block';
                        cbObj.checked = true;
                    }
                    else {
                        subchild.style.display = 'none';
                        subchild.children[0].style.display = 'none';
                        cbObj.checked = false;
                        if (!isNullOrUndefined(subchild.parentElement) && !isNullOrUndefined(subchild.parentElement.lastElementChild) && subchild.parentElement.lastElementChild.classList.contains('e-pv-organize-buttondiv')) {
                            subchild.parentElement.lastElementChild.style.display = 'none';
                        }
                    }
                }
            }
        }
    }
    onTooltipBeforeOpen(args) {
        if (!this.pdfViewer.toolbarSettings.showTooltip) {
            args.cancel = true;
        }
    }
    openContextMenu(event) {
        const contextMenu = document.getElementById(this.pdfViewer.element.id + '_organize_context_menu');
        if (!isNullOrUndefined(contextMenu) && contextMenu.style.display !== 'block') {
            this.contextMenuObj.open(event.originalEvent.clientY, event.originalEvent.clientX, event.originalEvent.currentTarget);
        }
    }
    updateTempRotationDetail(currentPageIndex, currentRotation) {
        if (this.pdfViewer.pageOrganizerSettings.canRotate) {
            const tempIndex = this.tempOrganizePagesCollection.findIndex((item) => item.currentPageIndex === currentPageIndex);
            if (tempIndex !== -1) {
                let rotateAngle = this.tempOrganizePagesCollection[parseInt(tempIndex.toString(), 10)].rotateAngle +
                    currentRotation;
                if (rotateAngle === -90) {
                    rotateAngle = 0;
                }
                // If the pageIndex is found in the array
                this.tempOrganizePagesCollection[parseInt(tempIndex.toString(), 10)].rotateAngle =
                    Math.abs((this.tempOrganizePagesCollection[parseInt(tempIndex.toString(), 10)].rotateAngle +
                        currentRotation + 360) % 360);
            }
        }
        this.organizeWindowFocus();
    }
    organizeWindowFocus() {
        const elementID = this.pdfViewer.element.id;
        document.getElementById(elementID + '_organize_window').focus();
    }
    getRotatedAngle(rotate) {
        switch (rotate.trim()) {
            case '0':
                return 0;
            case '90':
            case '1':
                return 90;
            case '180':
            case '2':
                return 180;
            case '270':
            case '3':
                return 270;
            case '360':
            case '4':
                return 0;
            default:
                return 0;
        }
    }
    getRotation(rotateAngle) {
        switch (rotateAngle.trim()) {
            case '0':
                return 0;
            case '90':
                return 1;
            case '180':
                return 2;
            case '270':
                return 3;
            case '360':
                return 0;
            default:
                return 0;
        }
    }
    updateRotationDetailCollection() {
        for (let i = 0; i < this.tempOrganizePagesCollection.length; i++) {
            const tempPageDetail = this.tempOrganizePagesCollection[parseInt(i.toString(), 10)];
            if (tempPageDetail.pageIndex !== -1) {
                const pageDetails = this.pdfViewerBase.pageSize[parseInt(tempPageDetail.pageIndex.toString(), 10)];
                if (Math.abs(this.getRotation(pageDetails.rotation.toString()) - tempPageDetail.rotateAngle) % 180 === 90) {
                    this.updatePageSize(tempPageDetail.pageIndex, pageDetails.height, pageDetails.width);
                }
            }
        }
    }
    updatePageSize(pageIndex, pageWidth, pageHeight) {
        if (this.pdfViewerBase.pageSize[parseInt(pageIndex.toString(), 10)]) {
            this.pdfViewerBase.pageSize[parseInt(pageIndex.toString(), 10)].width = pageWidth;
            this.pdfViewerBase.pageSize[parseInt(pageIndex.toString(), 10)].height = pageHeight;
            if (this.pdfViewerBase.highestWidth < pageWidth) {
                this.pdfViewerBase.highestWidth = pageWidth;
            }
            this.pdfViewerBase.isMixedSizeDocument = true;
        }
        for (let i = pageIndex; i < this.pdfViewerBase.pageSize.length; i++) {
            if (!this.pdfViewerBase.pageSize[parseInt((i - 1).toString(), 10)] && i - 1 < 0) {
                this.pdfViewerBase.pageSize[parseInt(i.toString(), 10)].top = this.pdfViewerBase.pageGap;
            }
            else {
                this.pdfViewerBase.pageSize[parseInt(i.toString(), 10)].top =
                    this.pdfViewerBase.pageSize[parseInt((i - 1).toString(), 10)].top +
                        this.pdfViewerBase.pageSize[parseInt((i - 1).toString(), 10)].height + this.pdfViewerBase.pageGap;
            }
        }
    }
    onSaveClicked() {
        this.isSkipRevert = true;
        this.showOrganizeLoadingIndicator(true);
        if ((JSON.stringify(this.tempOrganizePagesCollection) !== JSON.stringify(this.organizePagesCollection)) ||
            this.isDocumentModified) {
            this.updateOrganizePageCollection();
            this.isDocumentModified = true;
            let pdfBlob;
            this.pdfViewer.saveAsBlob().then((blob) => {
                pdfBlob = blob;
                this.blobToBase64(pdfBlob).then((base64) => {
                    if (!isNullOrUndefined(base64) && base64 !== '') {
                        const fileName = this.pdfViewer.fileName;
                        const downloadFileName = this.pdfViewer.downloadFileName;
                        const jsonDocumentId = this.pdfViewerBase.jsonDocumentId;
                        this.showOrganizeLoadingIndicator(false);
                        this.organizeDialog.hide();
                        this.undoOrganizeCollection = [];
                        this.redoOrganizeCollection = [];
                        this.pdfViewer.loadDocInternally(base64, null, false);
                        this.pdfViewerBase.updateDocumentEditedProperty(true);
                        this.pdfViewer.fileName = fileName;
                        if (!isNullOrUndefined(downloadFileName)) {
                            this.pdfViewer.downloadFileName = downloadFileName;
                        }
                        else {
                            this.pdfViewer.downloadFileName = fileName;
                        }
                        this.pdfViewerBase.jsonDocumentId = jsonDocumentId;
                    }
                });
            });
        }
        else {
            this.showOrganizeLoadingIndicator(false);
            this.organizeDialog.hide();
            this.undoOrganizeCollection = [];
            this.redoOrganizeCollection = [];
        }
    }
    blobToByteArray(blob) {
        // eslint-disable-next-line
        return new Promise(function (resolve, _) {
            const reader = new FileReader();
            reader.onloadend = function () {
                const arrayBuffer = reader.result;
                const byteArray = new Uint8Array(arrayBuffer);
                resolve(byteArray);
            };
            reader.readAsArrayBuffer(blob);
        });
    }
    blobToBase64(blob) {
        return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }
    /**
     * @param {boolean} isShow - specifies the isShow boolean.
     * @returns {void}
     * @private
     */
    showOrganizeLoadingIndicator(isShow) {
        const waitingPopup = document.getElementById(this.pdfViewer.element.id + '_organizeLoadingIndicator');
        if (waitingPopup) {
            if (isShow) {
                waitingPopup.style.display = 'block';
                showSpinner(waitingPopup);
            }
            else {
                waitingPopup.style.display = 'none';
                hideSpinner(waitingPopup);
            }
        }
    }
    updateOrganizePageDetailsInViewer() {
        for (const pageDetail of this.organizePagesCollection) {
            const pageIndex = pageDetail.pageIndex;
            const rotateAngle = pageDetail.rotateAngle;
            let pageSizeDetails;
            if (pageIndex !== -1) {
                pageSizeDetails = this.pdfViewerBase.pageSize[parseInt(pageIndex.toString(), 10)];
            }
            else {
                pageSizeDetails = this.pdfViewerBase.pageSize[parseInt(pageDetail.copiedPageIndex.toString(), 10)];
            }
            const pageWidth = pageSizeDetails.width * this.pdfViewerBase.getZoomFactor();
            const pageHeight = pageSizeDetails.height * this.pdfViewerBase.getZoomFactor();
            const pageTop = pageSizeDetails.top * this.pdfViewerBase.getZoomFactor();
            // Find the corresponding pageDiv using pageIndex
            const pageDiv = this.pdfViewerBase.getElement('_pageDiv_' + pageIndex);
            const pageCanvas = this.pdfViewerBase.getElement('_pageCanvas_' + pageIndex);
            if (pageDiv && pageCanvas) {
                pageDiv.style.width = pageWidth + 'px';
                pageDiv.style.height = pageHeight + 'px';
                if (this.pdfViewer.enableRtl) {
                    pageDiv.style.right = this.pdfViewerBase.updateLeftPosition(pageIndex) + 'px';
                }
                else {
                    pageDiv.style.left = this.pdfViewerBase.updateLeftPosition(pageIndex) + 'px';
                }
                pageDiv.style.top = pageTop + 'px';
                this.pdfViewerBase.pageContainer.style.width = (this.pdfViewerBase.isMixedSizeDocument && (this.pdfViewerBase.highestWidth * this.pdfViewerBase.getZoomFactor()) > this.pdfViewerBase.viewerContainer.clientWidth) ? (this.pdfViewerBase.highestWidth * this.pdfViewerBase.getZoomFactor()) + 'px' : this.pdfViewerBase.viewerContainer.clientWidth + 'px';
                // Update the width and height for div
                if (rotateAngle === 90 || rotateAngle === 270) {
                    const swapWidth = pageDiv.style.width;
                    pageDiv.style.width = pageDiv.style.height;
                    pageDiv.style.height = swapWidth;
                }
                else {
                    pageDiv.style.width = '';
                    pageDiv.style.height = '';
                }
                pageDiv.style.left = (this.pdfViewerBase.viewerContainer.clientWidth - (parseInt(pageDiv.style.width, 10) * this.pdfViewerBase.getZoomFactor())) / 2 + 'px';
                // Apply rotation to the canvas
                pageCanvas.style.transform = `rotate(${rotateAngle}deg)`;
                if (rotateAngle === 90 || rotateAngle === 270) {
                    const swap = pageCanvas.width;
                    pageCanvas.style.width = `${pageCanvas.height}px`;
                    pageCanvas.width = pageCanvas.height;
                    pageCanvas.style.height = `${swap}px`;
                    pageCanvas.height = swap;
                    pageCanvas.style.margin = '0px';
                    // Adjust margins to center the rotated canvas
                    pageCanvas.style.marginLeft = `${(pageCanvas.height - pageCanvas.width) / 2}px`;
                    pageCanvas.style.marginTop = `${(pageCanvas.width - pageCanvas.height) / 2}px`;
                }
                else {
                    // Reset margins if not rotated by 90 or 270 degrees
                    pageCanvas.style.margin = '0px';
                }
                this.applyElementStyles(pageCanvas, pageIndex);
            }
        }
    }
    getNextSubIndex(parentElement, parentPageIndex) {
        const elementsWithAnchorId = parentElement.querySelectorAll(`[id^='anchor_page_${parentPageIndex}']`);
        // Find the largest subindex among the existing elements
        let maxSubIndex = -1;
        elementsWithAnchorId.forEach((element) => {
            const [pageIndex, subIndex] = element.id.split('_').slice(2);
            if (Number(subIndex) > maxSubIndex) {
                maxSubIndex = Number(subIndex);
            }
        });
        return maxSubIndex + 1;
    }
    removePage(pageOrder) {
        const mainTileElement = this.tileAreaDiv.childNodes[parseInt(pageOrder.toString(), 10)];
        this.deleteTempPage(pageOrder, mainTileElement);
        this.tileAreaDiv.removeChild(mainTileElement);
        this.updatePageDetail();
    }
    rotateImage(currentPageIndex, rotationAngle) {
        const mainTileElement = this.tileAreaDiv.childNodes[parseInt(currentPageIndex.toString(), 10)];
        const imageContainer = mainTileElement.querySelector('.e-pv-organize-image');
        if (imageContainer) {
            let currentRotation = parseFloat(imageContainer.style.transform.replace('rotate(', '').replace('deg)', '')) || 0;
            currentRotation = (currentRotation + rotationAngle + 360) % 360;
            imageContainer.style.transform = `rotate(${currentRotation}deg)`;
            this.updateTempRotationDetail(currentPageIndex, rotationAngle);
        }
    }
    updatePageDetail() {
        this.updateTotalPageCount();
        this.updatePageNumber();
    }
    deletePageElement(mainTileElement) {
        if (this.pdfViewer.pageOrganizerSettings.canDelete && this.tileAreaDiv.childElementCount > 1) {
            const pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
            this.deleteTempPage(pageOrder, mainTileElement);
            const deleteButton = mainTileElement.querySelector('.e-pv-delete-button');
            if (!isNullOrUndefined(deleteButton) && !isNullOrUndefined(deleteButton.ej2_instances) &&
                deleteButton.ej2_instances.length > 0) {
                // We are destroying the button component to remove tooltip
                deleteButton.ej2_instances[0].destroy();
            }
            this.tileAreaDiv.removeChild(mainTileElement);
            this.updateTotalPageCount();
            this.updatePageNumber();
            this.updateSelectAllCheckbox();
            this.disableTileDeleteButton();
        }
    }
    deleteTempPage(currentPageIndex, tileDiv) {
        if (this.pdfViewer.pageOrganizerSettings.canDelete &&
            (this.tempOrganizePagesCollection.filter((item) => item.isDeleted === false).length > 0)) {
            const index = this.tempOrganizePagesCollection.findIndex((item) => item.currentPageIndex === currentPageIndex);
            const delCurrentIndex = this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].currentPageIndex;
            if (index !== -1 && !this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].isInserted &&
                !this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].isCopied &&
                !this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].isImportedDoc) {
                this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].isDeleted = true;
                this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].currentPageIndex = null;
            }
            else {
                this.tempOrganizePagesCollection.splice(index, 1);
            }
            this.tempOrganizePagesCollection = this.tempOrganizePagesCollection.map((item) => {
                if (delCurrentIndex < item.currentPageIndex && !item.isDeleted) {
                    item.currentPageIndex = item.currentPageIndex - 1;
                }
                return item;
            });
            while (!isNullOrUndefined(tileDiv.nextElementSibling)) {
                const nextTileDiv = tileDiv.nextElementSibling;
                let nextTileIndex = parseInt(nextTileDiv.getAttribute('data-page-order'), 10);
                nextTileIndex = nextTileIndex - 1;
                nextTileDiv.setAttribute('data-page-order', nextTileIndex.toString());
                tileDiv = nextTileDiv;
            }
        }
    }
    undoDeletedPage(deletedPageIndex, pageIndex, rotateAngle, tileDiv) {
        if (this.tempOrganizePagesCollection.some((item) => item.isDeleted)) {
            const deletedItem = this.tempOrganizePagesCollection.find((item) => item.currentPageIndex === null && item.isDeleted && item.pageIndex !== -1 && item.pageIndex === pageIndex &&
                item.copiedPageIndex === null);
            if (deletedItem) {
                deletedItem.currentPageIndex = deletedPageIndex;
                deletedItem.rotateAngle = rotateAngle;
            }
        }
        this.tempOrganizePagesCollection = this.tempOrganizePagesCollection.map((item) => {
            if (item.currentPageIndex >= deletedPageIndex && !item.isDeleted) {
                item.currentPageIndex += 1;
            }
            else if (item.currentPageIndex === deletedPageIndex && item.isDeleted) {
                item.isDeleted = false;
            }
            return item;
        });
        this.tempOrganizePagesCollection.sort(function (a, b) {
            return a.currentPageIndex - b.currentPageIndex;
        });
        if (tileDiv) {
            tileDiv.setAttribute('data-page-order', (deletedPageIndex + 1).toString());
        }
        while (tileDiv && !isNullOrUndefined(tileDiv.nextElementSibling)) {
            const nextTileDiv = tileDiv.nextElementSibling;
            let nextTileIndex = parseInt(nextTileDiv.getAttribute('data-page-order'), 10);
            nextTileIndex += 1;
            nextTileDiv.setAttribute('data-page-order', nextTileIndex.toString());
            tileDiv = nextTileDiv;
        }
    }
    insertRemovedPages(toolbarActions, currentPageIndex, tileDiv) {
        let deleteCount = 0;
        const index = this.tempOrganizePagesCollection.findIndex((item) => {
            return item.currentPageIndex === currentPageIndex;
        });
        if (index !== -1) {
            for (let i = 0; i < index; i++) {
                if (this.tempOrganizePagesCollection[parseInt(i.toString(), 10)].isDeleted) {
                    deleteCount++;
                }
            }
        }
        else {
            for (let i = 0; i < currentPageIndex; i++) {
                if (this.tempOrganizePagesCollection[parseInt(i.toString(), 10)].isDeleted) {
                    deleteCount++;
                }
            }
        }
        this.tempOrganizePagesCollection = this.tempOrganizePagesCollection.slice(0, currentPageIndex + deleteCount).
            concat(toolbarActions, this.tempOrganizePagesCollection.slice(currentPageIndex + deleteCount));
        this.tempOrganizePagesCollection = this.tempOrganizePagesCollection.map((item, mapIndex) => {
            if (mapIndex > currentPageIndex + deleteCount && !item.isDeleted) {
                item.currentPageIndex += 1;
            }
            return item;
        });
        if (tileDiv) {
            tileDiv.setAttribute('data-page-order', (currentPageIndex + 1).toString());
        }
        while (tileDiv && !isNullOrUndefined(tileDiv.nextElementSibling)) {
            const nextTileDiv = tileDiv.nextElementSibling;
            let nextTileIndex = parseInt(nextTileDiv.getAttribute('data-page-order'), 10);
            nextTileIndex = nextTileIndex + 1;
            nextTileDiv.setAttribute('data-page-order', nextTileIndex.toString());
            tileDiv = nextTileDiv;
        }
    }
    clonedCollection(tempCollecion) {
        const clonedCollection = JSON.parse(JSON.stringify(tempCollecion));
        return clonedCollection;
    }
    updateTotalPageCount() {
        const totalPages = document.querySelectorAll('.e-pv-organize-anchor-node').length;
        const totalPageNumberElement = document.querySelector('.e-pv-organize-total-page-button');
        if (!isNullOrUndefined(totalPageNumberElement)) {
            totalPageNumberElement.textContent = this.pdfViewer.localeObj.getConstant('Total') + ' ' + totalPages.toString() + ' ' + this.pdfViewer.localeObj.getConstant('Pages');
        }
    }
    updatePageNumber() {
        const totalPages = document.querySelectorAll('.e-pv-organize-anchor-node');
        totalPages.forEach((element) => {
            const pageOrder = parseInt(element.getAttribute('data-page-order'), 10);
            const thumbnailPageNumber = element.querySelector('.e-pv-tile-number');
            if (thumbnailPageNumber) {
                const currentPageNumber = this.tempOrganizePagesCollection.
                    find((item) => { return item.currentPageIndex === pageOrder; });
                if (currentPageNumber.isImportedDoc) {
                    thumbnailPageNumber.textContent = currentPageNumber.documentName;
                    const pageNumberTooltip = new Tooltip({
                        content: initializeCSPTemplate(function () { return thumbnailPageNumber.textContent; }, this), opensOn: 'Hover', beforeOpen: this.onTooltipBeforeOpen.bind(this)
                    });
                    pageNumberTooltip.appendTo(thumbnailPageNumber);
                }
                else {
                    thumbnailPageNumber.textContent = (pageOrder + 1).toString();
                }
            }
        });
        this.organizeWindowFocus();
    }
    insertTempPage(currentPageIndex, isBefore, tileDiv) {
        if (this.pdfViewer.pageOrganizerSettings.canInsert) {
            const index = this.tempOrganizePagesCollection.findIndex((item) => item.currentPageIndex === currentPageIndex);
            let beforeIndex;
            if (currentPageIndex !== 0) {
                beforeIndex =
                    this.tempOrganizePagesCollection.findIndex((item) => item.currentPageIndex === currentPageIndex - 1);
            }
            else {
                beforeIndex = index;
            }
            let pageIndex;
            let pageSize;
            if (isBefore) {
                pageIndex = this.tempOrganizePagesCollection[parseInt(beforeIndex.toString(), 10)].pageIndex;
                if (index - 1 >= 0 && !this.tempOrganizePagesCollection[parseInt((index - 1).toString(), 10)].isInserted) {
                    this.tempOrganizePagesCollection[parseInt((index - 1).toString(), 10)].hasEmptyPageAfter = true;
                }
                if (index <= this.tempOrganizePagesCollection.length - 1 &&
                    !this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].isInserted) {
                    this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].hasEmptyPageBefore = true;
                }
                pageSize = JSON.parse(JSON.stringify(this.tempOrganizePagesCollection[parseInt(beforeIndex.toString(), 10)].pageSize));
                if (pageIndex !== -1) {
                    if (!isNullOrUndefined(pageSize.rotation) &&
                        (this.getRotatedAngle(pageSize.rotation.toString()) === 90 ||
                            this.getRotatedAngle(pageSize.rotation.toString()) === 270)) {
                        const swapWidth = pageSize.width;
                        pageSize.width = pageSize.height;
                        pageSize.height = swapWidth;
                    }
                }
                this.tempOrganizePagesCollection = [...this.tempOrganizePagesCollection.slice(0, index),
                    new OrganizeDetails(currentPageIndex, -1, this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].pageIndex, true, false, false, false, false, false, this.tempOrganizePagesCollection[parseInt(beforeIndex.toString(), 10)].rotateAngle, pageSize, false, null, null, null),
                    ...this.tempOrganizePagesCollection.slice(index)];
                this.tempOrganizePagesCollection = this.tempOrganizePagesCollection.map((item, mapIndex) => {
                    if ((mapIndex !== index && item.currentPageIndex >= currentPageIndex) && item.currentPageIndex != null) {
                        item.currentPageIndex = item.currentPageIndex + 1;
                    }
                    return item;
                });
                tileDiv.setAttribute('data-page-order', (currentPageIndex + 1).toString());
            }
            else {
                pageIndex = this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].pageIndex;
                if (index >= 0 && !this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].isInserted) {
                    this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].hasEmptyPageAfter = true;
                }
                if (index + 1 <= this.tempOrganizePagesCollection.length - 1 &&
                    !this.tempOrganizePagesCollection[parseInt((index + 1).toString(), 10)].isInserted) {
                    this.tempOrganizePagesCollection[parseInt((index + 1).toString(), 10)].hasEmptyPageBefore = true;
                }
                pageSize = JSON.parse(JSON.stringify(this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].pageSize));
                if (pageIndex !== -1) {
                    if (!isNullOrUndefined(pageSize.rotation) &&
                        (this.getRotatedAngle(pageSize.rotation.toString()) === 90 ||
                            this.getRotatedAngle(pageSize.rotation.toString()) === 270)) {
                        const swapWidth = pageSize.width;
                        pageSize.width = pageSize.height;
                        pageSize.height = swapWidth;
                    }
                }
                this.tempOrganizePagesCollection = [...this.tempOrganizePagesCollection.slice(0, index + 1),
                    new OrganizeDetails(currentPageIndex + 1, -1, this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].pageIndex, true, false, false, false, false, false, this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].rotateAngle, pageSize, false, null, null, null),
                    ...this.tempOrganizePagesCollection.slice(index + 1)];
                this.tempOrganizePagesCollection = this.tempOrganizePagesCollection.map((item, mapIndex) => {
                    if ((mapIndex !== index + 1 && item.currentPageIndex >= currentPageIndex + 1) && item.currentPageIndex != null) {
                        item.currentPageIndex = item.currentPageIndex + 1;
                    }
                    return item;
                });
            }
            while (!isNullOrUndefined(tileDiv.nextElementSibling)) {
                const nextTileDiv = tileDiv.nextElementSibling;
                let nextTileIndex = parseInt(nextTileDiv.getAttribute('data-page-order'), 10);
                nextTileIndex = nextTileIndex + 1;
                nextTileDiv.setAttribute('data-page-order', nextTileIndex.toString());
                tileDiv = nextTileDiv;
            }
        }
    }
    copyPage(currentPageIndex, tileDiv) {
        if (this.pdfViewer.pageOrganizerSettings.canCopy) {
            const index = this.tempOrganizePagesCollection.findIndex((item) => {
                return item.currentPageIndex === currentPageIndex;
            });
            let pageIndex;
            let pageSize;
            if (index !== -1) {
                pageIndex = this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].pageIndex;
                pageSize = JSON.parse(JSON.stringify(this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].pageSize));
                if (pageIndex !== -1) {
                    // eslint-disable-next-line
                    if (!isNullOrUndefined(pageSize.rotation) && (this.getRotatedAngle(pageSize.rotation.toString()) == 90 ||
                        this.getRotatedAngle(pageSize.rotation.toString()) === 270)) {
                        const swapWidth = pageSize.width;
                        pageSize.width = pageSize.height;
                        pageSize.height = swapWidth;
                    }
                }
                if (pageIndex === -1 && this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].isCopied) {
                    this.tempOrganizePagesCollection = this.tempOrganizePagesCollection.slice(0, index + 1).
                        concat([new OrganizeDetails(currentPageIndex + 1, -1, this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].copiedPageIndex, false, false, true, false, false, false, this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].
                            rotateAngle, pageSize, false, null, null, null)], this.tempOrganizePagesCollection.slice(index + 1));
                }
                else {
                    this.tempOrganizePagesCollection = this.tempOrganizePagesCollection.slice(0, index + 1).
                        concat([new OrganizeDetails(currentPageIndex + 1, -1, pageIndex, false, false, true, false, false, false, this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].
                            rotateAngle, pageSize, false, null, null, null)], this.tempOrganizePagesCollection.slice(index + 1));
                }
                this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].istargetCopied = true;
                this.tempOrganizePagesCollection = this.tempOrganizePagesCollection.map((item, mapIndex) => {
                    if (mapIndex > index + 1 && item.currentPageIndex != null) {
                        item.currentPageIndex = item.currentPageIndex + 1;
                    }
                    return item;
                });
                while (!isNullOrUndefined(tileDiv.nextElementSibling)) {
                    const nextTileDiv = tileDiv.nextElementSibling;
                    let nextTileIndex = parseInt(nextTileDiv.getAttribute('data-page-order'), 10);
                    nextTileIndex = nextTileIndex + 1;
                    nextTileDiv.setAttribute('data-page-order', nextTileIndex.toString());
                    tileDiv = nextTileDiv;
                }
            }
        }
    }
    importPage(currentPageIndex, tileDiv, password, documentName, isBefore, documentData) {
        if (this.pdfViewer.pageOrganizerSettings.canImport) {
            const index = this.tempOrganizePagesCollection.findIndex((item) => {
                return item.currentPageIndex === currentPageIndex;
            });
            let pageIndex;
            let pageSize;
            if (index !== -1) {
                pageIndex = this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].pageIndex;
                pageSize = JSON.parse(JSON.stringify(this.tempOrganizePagesCollection[parseInt(index.toString(), 10)].pageSize));
                if (isBefore) {
                    this.tempOrganizePagesCollection = [...this.tempOrganizePagesCollection.slice(0, index),
                        new OrganizeDetails(currentPageIndex, -1, pageIndex, false, false, false, false, false, false, 0, pageSize, true, documentName, password, documentData),
                        ...this.tempOrganizePagesCollection.slice(index)];
                    this.tempOrganizePagesCollection = this.tempOrganizePagesCollection.map((item, mapIndex) => {
                        if ((mapIndex !== index && item.currentPageIndex >= currentPageIndex) && item.currentPageIndex != null) {
                            item.currentPageIndex = item.currentPageIndex + 1;
                        }
                        return item;
                    });
                    tileDiv.setAttribute('data-page-order', (currentPageIndex + 1).toString());
                }
                else {
                    this.tempOrganizePagesCollection = this.tempOrganizePagesCollection.slice(0, index + 1).
                        concat([new OrganizeDetails(currentPageIndex + 1, -1, pageIndex, false, false, false, false, false, false, 0, pageSize, true, documentName, password, documentData)], this.tempOrganizePagesCollection.slice(index + 1));
                    this.tempOrganizePagesCollection = this.tempOrganizePagesCollection.map((item, mapIndex) => {
                        if (mapIndex > index + 1 && item.currentPageIndex != null) {
                            item.currentPageIndex = item.currentPageIndex + 1;
                        }
                        return item;
                    });
                }
                while (!isNullOrUndefined(tileDiv.nextElementSibling)) {
                    const nextTileDiv = tileDiv.nextElementSibling;
                    // eslint-disable-next-line @typescript-eslint/indent
                    let nextTileIndex = parseInt(nextTileDiv.getAttribute('data-page-order'), 10);
                    nextTileIndex = nextTileIndex + 1;
                    nextTileDiv.setAttribute('data-page-order', nextTileIndex.toString());
                    tileDiv = nextTileDiv;
                }
            }
        }
    }
    organizeWireEvent() {
        if (this.importDocInputElement) {
            this.importDocInputElement.addEventListener('change', this.importDocument.bind(this));
        }
    }
    organizeUnWireEvent() {
        if (this.importDocInputElement) {
            this.importDocInputElement.removeEventListener('change', this.importDocument.bind(this));
        }
    }
    importDocument(args) {
        if (this.pdfViewer.pageOrganizerSettings.canImport) {
            // eslint-disable-next-line
            const proxy = this;
            const upoadedFiles = args.target.files;
            if (args.target.files[0] !== null) {
                const uploadedFile = upoadedFiles[0];
                if (uploadedFile) {
                    this.importedDocumentName = uploadedFile.name;
                    const reader = new FileReader();
                    reader.readAsDataURL(uploadedFile);
                    reader.onload = (e) => {
                        const uploadedFileUrl = e.currentTarget.result;
                        proxy.loadImportDoc(uploadedFileUrl, null, false);
                        if (!isNullOrUndefined(proxy.importDocInputElement)) {
                            proxy.importDocInputElement.value = '';
                        }
                    };
                }
            }
        }
    }
    /**
     * @param {string} documentData - specifies the documentData.
     * @param {string} password - specifies the password.
     * @param {boolean} isPasswordCorrect - specifies the isPasswordCorrect.
     * @returns {void}
     * @private
     */
    loadImportDoc(documentData, password, isPasswordCorrect) {
        if (this.pdfViewer.pageOrganizerSettings.canImport) {
            let proxy = null;
            // eslint-disable-next-line
            proxy = this;
            let isEncrypted = false;
            this.importedDocumentData = documentData;
            const documentId = this.pdfViewerBase.createGUID();
            const isbase64 = documentData.includes('pdf;base64,');
            const base64DocumentData = documentData;
            documentData = this.pdfViewerBase.checkDocumentData(documentData, false);
            const jsonObject = this.pdfViewerBase.constructJsonObject(documentData, password, isbase64);
            if (this.pdfViewer.serverActionSettings) {
                this.pdfViewerBase.loadRequestHandler = new AjaxHandler(this.pdfViewer);
                this.pdfViewerBase.loadRequestHandler.url = this.pdfViewer.serviceUrl + '/' + this.pdfViewer.serverActionSettings.validatePassword;
                this.pdfViewerBase.loadRequestHandler.responseType = 'json';
                this.pdfViewerBase.loadRequestHandler.mode = true;
                jsonObject['action'] = 'ValidatePassword';
                jsonObject['elementId'] = this.pdfViewer.element.id;
                jsonObject['isFileName'] = false;
                if (this.pdfViewerBase.clientSideRendering) {
                    this.pdfViewerBase.getPdfByteArray(base64DocumentData).then((pdfbytearray) => {
                        let data = this.pdfViewer.pdfRendererModule.loadImportDocument(pdfbytearray, documentId, password, jsonObject);
                        if (data) {
                            if (typeof data !== 'object') {
                                try {
                                    data = JSON.parse(data);
                                }
                                catch (error) {
                                    this.pdfViewerBase.onControlError(500, data, this.pdfViewer.serverActionSettings.load);
                                    data = null;
                                }
                            }
                            if (data) {
                                while (typeof data !== 'object') {
                                    data = JSON.parse(data);
                                    if (typeof parseInt(data, 10) === 'number' && !isNaN(parseInt(data, 10))) {
                                        data = parseInt(data, 10);
                                        break;
                                    }
                                }
                                if (data.uniqueId === documentId || (typeof parseInt(data, 10) === 'number' && !isNaN(parseInt(data, 10)))) {
                                    if (data === 4) {
                                        // 4 is error code for encrypted document.
                                        this.pdfViewerBase.isImportDoc = true;
                                        isEncrypted = true;
                                        this.pdfViewerBase.renderPasswordPopup(documentData, password, this.pdfViewerBase.isImportDoc);
                                    }
                                    else if (data === 3) {
                                        // 3 is error code for corrupted document.
                                        this.pdfViewerBase.isImportDoc = true;
                                        this.pdfViewerBase.renderCorruptPopup(this.pdfViewerBase.isImportDoc);
                                    }
                                }
                            }
                            if (isPasswordCorrect && data !== 4) {
                                this.pdfViewerBase.passwordDialogReset();
                                if (this.pdfViewerBase.passwordPopup) {
                                    this.pdfViewerBase.passwordPopup.hide();
                                }
                            }
                            if ((!isEncrypted || (isPasswordCorrect && data !== 4)) && (data !== 3)) {
                                this.importDocuments(password, this.importedDocumentName, documentData);
                            }
                        }
                    });
                }
                else {
                    this.pdfViewerBase.loadRequestHandler.send(jsonObject);
                    this.pdfViewerBase.loadRequestHandler.onSuccess = function (result) {
                        let data = result.data;
                        if (data) {
                            if (typeof data !== 'object') {
                                try {
                                    data = JSON.parse(data);
                                }
                                catch (error) {
                                    proxy.pdfViewerBase.onControlError(500, data, proxy.pdfViewer.serverActionSettings.load);
                                    data = null;
                                }
                            }
                            if (data) {
                                while (typeof data !== 'object') {
                                    data = JSON.parse(data);
                                    if (typeof parseInt(data, 10) === 'number' && !isNaN(parseInt(data, 10))) {
                                        data = parseInt(data, 10);
                                        break;
                                    }
                                }
                                if (data.uniqueId === documentId || (typeof parseInt(data, 10) === 'number' && !isNaN(parseInt(data, 10)))) {
                                    if (data === 4) {
                                        // 4 is error code for encrypted document.
                                        proxy.pdfViewerBase.isImportDoc = true;
                                        isEncrypted = true;
                                        proxy.pdfViewerBase.renderPasswordPopup(documentData, password, proxy.pdfViewerBase.isImportDoc);
                                    }
                                    else if (data === 3) {
                                        // 3 is error code for corrupted document.
                                        proxy.pdfViewerBase.isImportDoc = true;
                                        proxy.pdfViewerBase.renderCorruptPopup(proxy.pdfViewerBase.isImportDoc);
                                    }
                                }
                            }
                            if (isPasswordCorrect && data !== 4) {
                                proxy.pdfViewerBase.passwordDialogReset();
                                if (proxy.pdfViewerBase.passwordPopup) {
                                    proxy.pdfViewerBase.passwordPopup.hide();
                                }
                            }
                            if ((!isEncrypted || (isPasswordCorrect && data !== 4)) && (data !== 3)) {
                                proxy.importDocuments(password, proxy.importedDocumentName, documentData);
                            }
                        }
                    };
                }
            }
        }
    }
    importDocuments(password, documentName, documentData) {
        if (this.pdfViewer.pageOrganizerSettings.canImport) {
            // eslint-disable-next-line
            const proxy = this;
            if (this.tileAreaDiv.querySelectorAll('.e-pv-organize-node-selection-ring').length === 1) {
                for (let i = 0; i < proxy.tileAreaDiv.childElementCount; i++) {
                    const mainTileElement = proxy.tileAreaDiv.childNodes[parseInt(i.toString(), 10)];
                    if (mainTileElement instanceof HTMLElement && mainTileElement.classList.contains('e-pv-organize-node-selection-ring')) {
                        const pageId = mainTileElement.id.split('anchor_page_')[mainTileElement.id.split('anchor_page_').length - 1];
                        const pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
                        const pageIdlist = pageId.split('_');
                        let subIndex = 0;
                        let pageIndex = parseInt(pageIdlist[parseInt((pageIdlist.length - 1).toString(), 10)], 10);
                        if (pageIdlist.length > 1) {
                            pageIndex = parseInt(pageIdlist[parseInt((pageIdlist.length - 2).toString(), 10)], 10);
                        }
                        subIndex = this.getNextSubIndex(mainTileElement.parentElement, pageIndex);
                        this.importPage(pageOrder, mainTileElement, password, documentName, false, documentData);
                        this.tileImageRender(pageIndex, subIndex, pageOrder + 1, mainTileElement, true, false, false, true, documentName);
                        const clonedCollection = [];
                        clonedCollection.push(this.clonedCollection(this.tempOrganizePagesCollection.
                            find((item) => { return item.currentPageIndex === (pageOrder + 1); })));
                        this.addOrganizeAction(clonedCollection, 'Import Pages', [], [], null, false);
                    }
                }
            }
            else {
                const mainTileElement = proxy.tileAreaDiv.childNodes[0];
                const pageId = mainTileElement.id.split('anchor_page_')[mainTileElement.id.split('anchor_page_').length - 1];
                const pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
                const pageIdlist = pageId.split('_');
                let subIndex = 0;
                let pageIndex = parseInt(pageIdlist[parseInt((pageIdlist.length - 1).toString(), 10)], 10);
                if (pageIdlist.length > 1) {
                    pageIndex = parseInt(pageIdlist[parseInt((pageIdlist.length - 2).toString(), 10)], 10);
                }
                subIndex = this.getNextSubIndex(mainTileElement.parentElement, pageIndex);
                this.importPage(pageOrder, mainTileElement, password, documentName, true, documentData);
                this.tileImageRender(pageIndex, subIndex, pageOrder, mainTileElement, true, true, false, true, documentName);
                const clonedCollection = [];
                clonedCollection.push(this.clonedCollection(this.tempOrganizePagesCollection.
                    find((item) => { return item.currentPageIndex === pageOrder; })));
                this.addOrganizeAction(clonedCollection, 'Import Pages', [], [], null, false);
            }
            this.updatePageNumber();
            this.updateTotalPageCount();
            this.enableDisableToolbarItems();
            this.disableTileCopyRotateButton();
            this.disableTileDeleteButton();
        }
    }
    updateOrganizePageCollection() {
        this.organizePagesCollection = JSON.parse(JSON.stringify(this.tempOrganizePagesCollection));
    }
    /**
     *
     * @param {any} pageCanvas - It describes about the page canvas
     * @param {number} pageNumber - It describes about the page number
     * @private
     * @returns {void}
     */
    applyElementStyles(pageCanvas, pageNumber) {
        if (pageCanvas) {
            const canvasElement = document.getElementById(this.pdfViewer.element.id + '_pageCanvas_' + pageNumber);
            const oldCanvas = document.getElementById(this.pdfViewer.element.id + '_oldCanvas_' + pageNumber);
            if (canvasElement && canvasElement.offsetLeft > 0) {
                // Update marginLeft, marginRight, and top positions
                const offsetLeft = canvasElement.offsetLeft;
                const offsetTop = canvasElement.offsetTop;
                pageCanvas.style.marginLeft = offsetLeft + 'px';
                pageCanvas.style.marginRight = offsetLeft + 'px';
                pageCanvas.style.top = offsetTop + 'px';
            }
            else if (oldCanvas && oldCanvas.offsetLeft > 0) {
                // Update marginLeft, marginRight, and top positions using oldCanvas
                const offsetLeft = oldCanvas.offsetLeft;
                const offsetTop = oldCanvas.offsetTop;
                pageCanvas.style.marginLeft = offsetLeft + 'px';
                pageCanvas.style.marginRight = offsetLeft + 'px';
                pageCanvas.style.top = offsetTop + 'px';
            }
            else {
                // Reset the positions
                pageCanvas.style.marginLeft = 'auto';
                pageCanvas.style.marginRight = 'auto';
                pageCanvas.style.top = 'auto';
            }
        }
    }
    onSaveasClicked() {
        if (JSON.stringify(this.tempOrganizePagesCollection) !== JSON.stringify(this.organizePagesCollection)) {
            this.updateOrganizePageCollection();
            this.isDocumentModified = true;
            this.pdfViewerBase.updateDocumentEditedProperty(true);
        }
        const fileName = this.pdfViewer.fileName;
        let pdfBlob;
        let canDownload = false;
        const temp = JSON.parse(JSON.stringify(this.organizePagesCollection));
        this.pdfViewer.saveAsBlob().then((blob) => {
            pdfBlob = blob;
            const conversionPromise = this.pdfViewerBase.clientSideRendering
                ? this.blobToByteArray(pdfBlob)
                : this.blobToBase64(pdfBlob);
            conversionPromise.then((result) => {
                if (!isNullOrUndefined(result) && result !== '') {
                    canDownload = this.pdfViewer.firePageOrganizerSaveAsEventArgs(fileName, result);
                    if (canDownload) {
                        this.pdfViewerBase.fileDownload(result, this.pdfViewerBase, true);
                        this.organizePagesCollection = JSON.parse(JSON.stringify(temp));
                    }
                }
            });
        });
    }
    /**
     *
     * Rotates all pages in the PDF Viewer by the specified angle.
     *
     * @param {PdfPageRotateAngle} pageRotateAngle - The angle by which to rotate the pages (PdfPageRotateAngle).
     *                          The rotation can be 0, 90, 180, or 270 degrees.
     * @returns {void}
     * @private
     */
    rotateAllPages(pageRotateAngle) {
        if (this.pdfViewer.pageOrganizerSettings.canRotate) {
            const rotateAngle = pageRotateAngle;
            // Get the total page count
            const totalPages = this.pdfViewer.pageCount;
            // Generate an array of page indexes
            const pageIndexes = Array.from({ length: totalPages }, (_, index) => index);
            this.processRotation(pageIndexes, rotateAngle);
        }
    }
    /**
     * @param {number} arg1 - It describes about the arg1
     * @param {number} arg2 - It describes about the arg2
     * @private
     * @returns {void}
     */
    rotatePages(arg1, arg2) {
        if (this.pdfViewer.pageOrganizerSettings.canRotate) {
            if (Array.isArray(arg1)) {
                // Check if the second argument is provided and is of type PdfPageRotateAngle
                if (arg2 !== undefined && typeof arg2 === 'number') {
                    const pageIndexes = arg1;
                    const rotateAngle = arg2;
                    this.processRotation(pageIndexes, rotateAngle);
                }
                else {
                    // Handle case: RotatePages(pageRotations: PageRotation[])
                    const pageRotations = arg1;
                    for (const pageRotation of pageRotations) {
                        this.processRotation([pageRotation.pageIndex], pageRotation.rotationAngle);
                    }
                }
            }
            else if (typeof arg1 === 'number' && typeof arg2 === 'number') {
                // Handle case: RotatePages(pageStartIndex, pageEndIndex, PdfPageRotateAngle.RotateAngle90)
                const pageStartIndex = arg1;
                const pageEndIndex = arg2;
                // eslint-disable-next-line
                const rotateAngle = arguments[2];
                this.processRotation(this.generateRange(pageStartIndex, pageEndIndex), rotateAngle);
            }
        }
    }
    processRotation(pageIndexes, pageRotateAngle) {
        if (this.pdfViewer.pageOrganizerSettings.canRotate) {
            // Iterate through the provided page numbers
            for (const pageIndex of pageIndexes) {
                const rotateAngle = this.pdfRotateAngle(pageRotateAngle);
                // Find the index of the page in the rotationDetail array
                const index = this.organizePagesCollection.findIndex((item) => item.pageIndex === pageIndex);
                // Check if the page is already in the rotationDetail array
                if (index !== -1) {
                    // If the pageIndex is found in the array, update the rotation angle
                    this.organizePagesCollection[parseInt(index.toString(), 10)].rotateAngle =
                        (this.organizePagesCollection[parseInt(index.toString(), 10)].rotateAngle + rotateAngle + 360) % 360;
                }
            }
        }
    }
    generateRange(start, end) {
        return Array.from({ length: end - start + 1 }, (_, index) => start + index);
    }
    pdfRotateAngle(rotateAngle) {
        let angle = 0;
        if (rotateAngle === PdfPageRotateAngle.RotateAngle0) {
            angle = 0;
        }
        else if (rotateAngle === PdfPageRotateAngle.RotateAngle90) {
            angle = 90;
        }
        else if (rotateAngle === PdfPageRotateAngle.RotateAngle180) {
            angle = 180;
        }
        else if (rotateAngle === PdfPageRotateAngle.RotateAngle270) {
            angle = 270;
        }
        else if (rotateAngle === PdfPageRotateAngle.RotateAngle360) {
            angle = 0;
        }
        return angle;
    }
    createTooltip(toolbarItem, tooltipText) {
        if (tooltipText !== null) {
            const tooltip = new Tooltip({
                content: initializeCSPTemplate(function () { return tooltipText; }), opensOn: 'Hover', beforeOpen: this.onTooltipBeforeOpen.bind(this)
            });
            tooltip.appendTo(toolbarItem);
        }
    }
    /**
     * @private
     * @param {number} newSize The size to which image zoom is to be updated
     * @param {number} oldSize The present value of image zoom
     * @returns {void}
     */
    updateOrganizePageImageSize(newSize, oldSize) {
        if (!isNullOrUndefined(oldSize)) {
            if (oldSize === newSize) {
                return;
            }
        }
        if (this.pdfViewerBase.clientSideRendering) {
            this.pdfViewerBase.pdfViewerRunner.removePreviewImageTasks(newSize);
        }
        this.lastRequestedPageIndex = 0;
        this.dataDetails = [];
        this.isPageZoomChanged = true;
        if (!this.isOrganizeWindowOpen) {
            if (!isNullOrUndefined(this.pdfViewerBase.navigationPane)) {
                this.pdfViewerBase.navigationPane.enableOrganizeButton(false);
            }
            if (!isNullOrUndefined(this.toolbar)) {
                this.pdfViewer.toolbar.enableToolbarItem(['OrganizePagesTool'], false);
            }
            if (this.isOrganizeDialogRendered()) {
                this.modifyThumbnailContainer();
            }
        }
        else {
            this.showOrganizeLoadingIndicator(true);
            this.modifyThumbnailContainer();
            if (this.isPageZoomPopupOpen) {
                this.updatePageZoomPopup();
            }
        }
        this.isAllImagesReceived = false;
        this.createRequestForPreview();
    }
    /**
     * Rotates the specified pages clockwise by 90 degrees.
     *
     * @param {number} pageNumbers - Array of page numbers to rotate.
     * @private
     * @returns {void}
     */
    rotateClockwise(pageNumbers) {
        if (this.pdfViewer.pageOrganizerSettings.canRotate) {
            // Iterate through the provided page numbers
            for (const pageIndex of pageNumbers) {
                // Find the index of the page in the rotationDetail array
                const index = this.organizePagesCollection.findIndex((item) => item.pageIndex === pageIndex);
                // Check if the page is already in the rotationDetail array
                if (index !== -1) {
                    // If the pageIndex is found in the array, update the rotation angle
                    this.organizePagesCollection[parseInt(index.toString(), 10)].rotateAngle =
                        (this.organizePagesCollection[parseInt(index.toString(), 10)].rotateAngle + 90 + 360) % 360;
                }
            }
        }
    }
    /**
     * Rotates the specified pages counterclockwise by 90 degrees.
     *
     * @param {number} pageNumbers - Array of page numbers to rotate.
     * @private
     * @returns {void}
     */
    rotateCounterclockwise(pageNumbers) {
        if (this.pdfViewer.pageOrganizerSettings.canRotate) {
            // Iterate through the provided page numbers
            for (const pageIndex of pageNumbers) {
                // Find the index of the page in the rotationDetail array
                const index = this.organizePagesCollection.findIndex((item) => item.pageIndex === pageIndex);
                // Check if the page is already in the rotationDetail array
                if (index !== -1) {
                    // If the pageIndex is found in the array, update the rotation angle
                    this.organizePagesCollection[parseInt(index.toString(), 10)].rotateAngle =
                        (this.organizePagesCollection[parseInt(index.toString(), 10)].rotateAngle - 90 + 360) % 360;
                }
            }
        }
    }
    /**
     * Opens the page organizer dialog within the Pdf Viewer, allowing for management of PDF pages.
     *
     * ```html
     * <div id="pdfViewer" style="height: 100%;width: 100%;"></div>
     * ```
     * ```ts
     * let viewer: PdfViewer = new PdfViewer();
     * viewer.appendTo("#pdfViewer");
     * viewer.documentLoad = () => {
     *      viewer.pageOrganizer.openPageOrganizer();
     * }
     * ```
     *
     * @returns {void}
     */
    openPageOrganizer() {
        if (!isNullOrUndefined(this.pdfViewer.pageOrganizer)) {
            if (this.isAllImagesReceived) {
                if (!Browser.isDevice || this.pdfViewer.enableDesktopMode) {
                    this.createOrganizeWindow();
                }
                else {
                    this.createOrganizeWindowForMobile();
                }
            }
        }
        else {
            this.pdfViewerBase.getModuleWarningMessage('PageOrganizer');
        }
    }
    /**
     * Closes the currently open page organizer dialog within the PDF Viewer, if present.
     *
     * ```html
     * <div id="pdfViewer" style="height: 100%;width: 100%;"></div>
     * ```
     * ```ts
     * let viewer: PdfViewer = new PdfViewer();
     * viewer.appendTo("#pdfViewer");
     * viewer.documentLoad = () => {
     *      viewer.pageOrganizer.closePageOrganizer();
     * }
     * ```
     *
     * @returns {void}
     */
    closePageOrganizer() {
        if (!isNullOrUndefined(this.pdfViewer.pageOrganizer)) {
            if (!isNullOrUndefined(this.organizeDialog)) {
                this.organizeDialog.hide();
            }
        }
        else {
            this.pdfViewerBase.getModuleWarningMessage('PageOrganizer');
        }
    }
    /**
     * @private
     * @param {PageOrganizerSettingsModel} newProp The new pageOrganizerSettings Property of PdfViewer from onPropertyChanged
     * @returns {void}
     */
    handleImageSizeBoundsChange(newProp) {
        if (!isNullOrUndefined(newProp.imageZoomMin)) {
            this.pdfViewer.pageOrganizerSettings.imageZoomMin = newProp.imageZoomMin;
        }
        if (!isNullOrUndefined(newProp.imageZoomMax)) {
            this.pdfViewer.pageOrganizerSettings.imageZoomMax = newProp.imageZoomMax;
        }
        if (!isNullOrUndefined(this.pageZoomSlider)) {
            this.pageZoomSlider.min = this.getImageZoomMin();
            this.pageZoomSlider.max = this.getImageZoomMax();
        }
    }
    /**
     * @private
     * @param {boolean} showImageZoomingSlider The new showImageZoomingSlider property of PdfViewer.PageOrganizerSettings from onPropertyChanged
     * @returns {void}
     */
    handleImageResizerVisibility(showImageZoomingSlider) {
        if (!this.isOrganizeDialogRendered()) {
            return;
        }
        if (isNullOrUndefined(showImageZoomingSlider) || !showImageZoomingSlider) {
            const resizerIndex = this.toolbar.items.findIndex((item) => item.id === this.pdfViewer.element.id + '_page_zoom');
            if (resizerIndex !== -1) {
                if (Browser.isDevice && !this.pdfViewer.enableDesktopMode) {
                    this.toolbar.hideItem(this.pdfViewerBase.getElement('_page_zoom').parentElement, true);
                }
                else {
                    this.toolbar.removeItems(this.pdfViewerBase.getElement('_page_zoom').parentElement);
                }
                if (!isNullOrUndefined(this.pageZoomSlider)) {
                    this.pageZoomSliderUnwireEvents();
                    this.pageZoomSlider.destroy();
                    this.pageZoomSlider = null;
                }
                if (!isNullOrUndefined(this.pageZoomDropDown)) {
                    this.pageZoomUnWireEvents();
                    this.pageZoomDropDown.destroy();
                    this.pageZoomDropDown = null;
                }
                if (!isNullOrUndefined(this.pageZoomIncreaseButton)) {
                    this.pageZoomIncreaseButton = null;
                }
                if (!isNullOrUndefined(this.pageZoomDecreaseButton)) {
                    this.pageZoomDecreaseButton = null;
                }
                // Removes the margin left or margin right property of center group in page organizer toolbar
                this.toolbar.element.children[0].children[1].removeAttribute('style');
            }
        }
        else {
            const pageZoomIndex = this.toolbar.items.findIndex((item) => item.id === this.pdfViewer.element.id + '_page_zoom');
            if (pageZoomIndex === -1 || (Browser.isDevice && !this.pdfViewer.enableDesktopMode)) {
                this.addPageZoomDropDown(false);
                this.createPageZoomDropDown();
            }
        }
        if (this.isOrganizeWindowOpen) {
            if ((Browser.isDevice && !this.pdfViewer.enableDesktopMode) && showImageZoomingSlider) {
                this.toolbar.refreshOverflow();
                this.handlePageZoomPopupMobile();
            }
        }
    }
    /**
     * @private
     * @returns {void}
     */
    switchPageOrganizer() {
        if (!isNullOrUndefined(this.pdfViewer.pageOrganizer)) {
            if (!isNullOrUndefined(this.organizeDialog) && this.organizeDialog.visible) {
                this.closePageOrganizer();
            }
            else {
                this.openPageOrganizer();
            }
        }
    }
    /**
     * @private
     * @returns {void}
     */
    getModuleName() {
        return 'PageOrganizer';
    }
    /**
     * @param {HTMLDivElement} imageContainer Div element whose margin is to be calculated
     * @private
     * @returns {number} imageZoom factor according to screen size
     */
    getImageZoomFactor(imageContainer) {
        const minValue = this.getImageZoomMin();
        if (!this.pdfViewer.enablePageOrganizer || isNullOrUndefined(this.pdfViewer.pageOrganizerSettings)) {
            return minValue;
        }
        const size = this.getImageZoomValue();
        if (isNullOrUndefined(size)) {
            return minValue;
        }
        const maxValue = this.getImageZoomMax();
        if (!Browser.isDevice || this.pdfViewer.enableDesktopMode) {
            return this.getImageZoomValue();
        }
        else {
            const viewportWidth = this.pdfViewer.element.clientWidth;
            const imageContainerWidth = 140;
            imageContainer.style.position = 'absolute';
            document.body.appendChild(imageContainer);
            const computedStyle = window.getComputedStyle(imageContainer);
            const margin = parseFloat(computedStyle.marginLeft) + parseFloat(computedStyle.marginRight);
            document.body.removeChild(imageContainer);
            if ((imageContainerWidth * maxValue) <= (viewportWidth - margin)) {
                return this.getImageZoomValue();
            }
            else {
                const maxFactor = (viewportWidth - margin) / imageContainerWidth;
                const factor = (maxFactor - minValue) / (maxValue - minValue);
                if (size < minValue) {
                    return minValue;
                }
                if (size > maxValue) {
                    return (minValue + ((maxValue - minValue) * factor));
                }
                return (minValue + ((size - minValue) * factor));
            }
        }
    }
    /**
     * @private
     * @param {boolean} isImageRequest defines if the function is called for image request
     * @param {number} size optional size can be sent to check valid page zoom value
     * @returns {number} imageZoom value
     */
    getImageZoomValue(isImageRequest, size) {
        const minValue = this.getImageZoomMin();
        if (!this.pdfViewer.enablePageOrganizer || isNullOrUndefined(this.pdfViewer.pageOrganizerSettings)) {
            return minValue;
        }
        if (isNullOrUndefined(size)) {
            size = this.pdfViewer.pageOrganizerSettings.imageZoom;
            if (isNullOrUndefined(size)) {
                return minValue;
            }
        }
        const maxValue = this.getImageZoomMax();
        if (size < minValue) {
            return minValue;
        }
        if (size > maxValue) {
            return maxValue;
        }
        if (isImageRequest) {
            return Math.round(size);
        }
        return size;
    }
    destroyDialogWindow() {
        this.removeEventListeners();
        this.isOrganizeWindowOpen = false;
        if (!isNullOrUndefined(this.pageZoomSlider)) {
            this.pageZoomSliderUnwireEvents();
            this.pageZoomSlider.destroy();
            this.pageZoomSlider = null;
        }
        if (!isNullOrUndefined(this.pageZoomDropDown)) {
            this.pageZoomUnWireEvents();
            this.pageZoomDropDown.destroy();
            this.pageZoomDropDown = null;
        }
        if (!isNullOrUndefined(this.organizeDialog)) {
            this.organizeUnWireEvent();
            this.organizeDialog.destroy();
            this.organizeDialog = null;
        }
        const dialogElement = this.pdfViewerBase.getElement('_organize_window');
        if (!isNullOrUndefined(dialogElement)) {
            dialogElement.parentElement.removeChild(dialogElement);
        }
        const pageZoomPopup = this.pdfViewerBase.getElement('_page_zoom-popup');
        if (!isNullOrUndefined(pageZoomPopup)) {
            pageZoomPopup.parentElement.removeChild(pageZoomPopup);
        }
    }
    pageZoomWireEvents() {
        if (!isNullOrUndefined(this.pageZoomDropDown)) {
            this.boundPageZoomDropDownOpen = this.pageZoomDropDownOpen.bind(this);
            this.boundPageZoomDropDownClose = this.pageZoomDropDownClose.bind(this);
            this.pageZoomDropDown.open = this.boundPageZoomDropDownOpen;
            this.pageZoomDropDown.close = this.boundPageZoomDropDownClose;
        }
        if (!isNullOrUndefined(this.pageZoomDecreaseButton)) {
            this.boundDecreasePageZoom = this.decreasePageZoom.bind(this);
            this.pageZoomDecreaseButton.addEventListener('click', this.boundDecreasePageZoom);
        }
        if (!isNullOrUndefined(this.pageZoomIncreaseButton)) {
            this.boundIncreasePageZoom = this.increasePageZoom.bind(this);
            this.pageZoomIncreaseButton.addEventListener('click', this.boundIncreasePageZoom);
        }
    }
    increasePageZoom() {
        if (this.pageZoomSlider.value + this.pageZoomSliderStep <= this.getImageZoomMax()) {
            this.handlePageZoomChange(this.pageZoomSlider.value + this.pageZoomSliderStep, this.pageZoomSlider.value);
        }
        else {
            if (this.pageZoomSlider.value !== this.getImageZoomMax()) {
                this.handlePageZoomChange(this.getImageZoomMax(), this.pageZoomSlider.value);
            }
        }
    }
    decreasePageZoom() {
        if (this.pageZoomSlider.value - this.pageZoomSliderStep >= this.getImageZoomMin()) {
            this.handlePageZoomChange(this.pageZoomSlider.value - this.pageZoomSliderStep, this.pageZoomSlider.value);
        }
        else {
            if (this.pageZoomSlider.value !== this.getImageZoomMin()) {
                this.handlePageZoomChange(this.getImageZoomMin(), this.pageZoomSlider.value);
            }
        }
    }
    handlePageZoomChange(currentValue, previousValue) {
        this.currentPageZoomSliderValue = currentValue;
        this.pdfViewer.pageOrganizerSettings.imageZoom = currentValue;
        this.updatePageZoomPopup();
        if (this.previouslyRequestedImageZoom < Math.round(currentValue)) {
            this.previouslyRequestedImageZoom = Math.round(currentValue);
            this.updateOrganizePageImageSize(Math.round(currentValue));
            this.previousImageZoom = previousValue;
        }
        else {
            const organizeNodes = this.tileAreaDiv.children;
            const imageSizeFactor = this.getImageZoomFactor(organizeNodes[0].cloneNode(true));
            /* eslint-disable security/detect-object-injection */
            for (let index = 0; index < organizeNodes.length; index++) {
                const imageContainer = organizeNodes[index];
                imageContainer.style.width = 140 * imageSizeFactor + 'px';
                imageContainer.style.height = 140 * imageSizeFactor + 'px';
            }
            /* eslint-enable security/detect-object-injection */
            if (this.pdfViewerBase.getElement('_organizeLoadingIndicator').style.display !== 'block') {
                this.currentImageZoom = currentValue;
                this.previousImageZoom = previousValue;
                if (this.currentImageZoom !== this.previousImageZoom) {
                    this.pdfViewer.firePageOrganizerZoomChanged(this.previousImageZoom, this.currentImageZoom);
                }
            }
        }
        this.handlePageZoomButtonsVisibility(currentValue);
    }
    pageZoomUnWireEvents() {
        if (!isNullOrUndefined(this.pageZoomDropDown)) {
            this.pageZoomDropDown.removeEventListener('open', this.boundPageZoomDropDownOpen);
            this.pageZoomDropDown.removeEventListener('close', this.boundPageZoomDropDownClose);
        }
        if (!isNullOrUndefined(this.pageZoomDecreaseButton)) {
            this.pageZoomDecreaseButton.removeEventListener('click', this.boundDecreasePageZoom);
        }
        if (!isNullOrUndefined(this.pageZoomIncreaseButton)) {
            this.pageZoomIncreaseButton.removeEventListener('click', this.boundIncreasePageZoom);
        }
    }
    pageZoomSliderWireEvents() {
        if (!isNullOrUndefined(this.pageZoomSlider)) {
            this.boundPageZoomChange = this.pageZoomChange.bind(this);
            this.pageZoomSlider.change = this.boundPageZoomChange;
            this.pageZoomSlider.changed = this.boundPageZoomChange;
        }
    }
    pageZoomSliderUnwireEvents() {
        if (!isNullOrUndefined(this.pageZoomSlider)) {
            this.pageZoomSlider.removeEventListener('change', this.boundPageZoomChange);
            this.pageZoomSlider.removeEventListener('changed', this.boundPageZoomChange);
        }
    }
    /**
     * @private
     * @returns {void}
     */
    clear() {
        if (!isNullOrUndefined(this.pdfViewerBase.navigationPane)) {
            this.pdfViewerBase.navigationPane.enableOrganizeButton(false);
        }
        if (!isNullOrUndefined(this.pdfViewer.toolbar)) {
            this.pdfViewer.toolbar.enableToolbarItem(['OrganizePagesTool'], false);
        }
        this.destroyDialogWindow();
        this.organizePagesCollection = [];
        this.tempOrganizePagesCollection = [];
        this.undoOrganizeCollection = [];
        this.redoOrganizeCollection = [];
        this.isDocumentModified = false;
        this.pdfViewerBase.isImportDoc = false;
        this.mobileContextMenu = [];
        this.dataDetails = [];
        this.isInitialLoading = true;
        this.isPageZoomPopupOpen = false;
        this.lastRequestedPageIndex = 0;
        this.previouslyRequestedImageZoom = Math.round(this.currentPageZoomSliderValue);
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        return true;
    }
}
/**
 * Enum for PdfPageRotateAngle
 */
export var PdfPageRotateAngle;
(function (PdfPageRotateAngle) {
    PdfPageRotateAngle[PdfPageRotateAngle["RotateAngle0"] = 1] = "RotateAngle0";
    PdfPageRotateAngle[PdfPageRotateAngle["RotateAngle90"] = 2] = "RotateAngle90";
    PdfPageRotateAngle[PdfPageRotateAngle["RotateAngle180"] = 3] = "RotateAngle180";
    PdfPageRotateAngle[PdfPageRotateAngle["RotateAngle270"] = 4] = "RotateAngle270";
    PdfPageRotateAngle[PdfPageRotateAngle["RotateAngle360"] = 1] = "RotateAngle360";
})(PdfPageRotateAngle || (PdfPageRotateAngle = {}));
export class PageRotation {
    // eslint-disable-next-line
    constructor(pageIndex, rotationAngle) {
        this.pageIndex = pageIndex;
        this.rotationAngle = rotationAngle;
    }
}
/**
 * Interface representing details about organizing pages, including page ID, current page index, rotate angle, and status of insertion and deletion.
 */
export class OrganizeDetails {
    constructor(currentPageIndex, pageIndex, copiedPageIndex, isInserted, isDeleted, isCopied, istargetCopied, hasEmptyPageAfter, hasEmptyPageBefore, rotateAngle, pageSize, isImportedDoc, documentName, password, documentData) {
        this.currentPageIndex = currentPageIndex;
        this.pageIndex = pageIndex;
        this.copiedPageIndex = copiedPageIndex;
        this.isInserted = isInserted;
        this.isDeleted = isDeleted;
        this.isCopied = isCopied;
        this.istargetCopied = istargetCopied;
        this.hasEmptyPageAfter = hasEmptyPageAfter;
        this.hasEmptyPageBefore = hasEmptyPageBefore;
        this.rotateAngle = rotateAngle;
        this.pageSize = pageSize;
        this.isImportedDoc = isImportedDoc;
        this.documentName = documentName;
        this.password = password;
        this.documentData = documentData;
    }
}
